// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* App.css */

.video-player-controls-top {
  width: 100%;
  display: flex;
  justify-content: space-between; /* Change to space-between */
  align-items: center; /* Vertically align items */
  margin-bottom: 10px; /* Add some space below */
}

.language-selector-top {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 1em; /* Increase font size slightly */
  color: #333; /* Darker text for better readability */
}

.custom-select-wrapper {
  position: relative;
  display: inline-block;
}

.custom-select {
  appearance: none;
  background-color: #f8f9fa; /* Lighter background */
  border: 1px solid #ced4da; /* Standard border */
  border-radius: 5px;
  color: #333; /* Darker text */
  padding: 8px 30px 8px 12px;
  font-size: 1em;
  cursor: pointer;
  transition: background-color 0.2s ease, border-color 0.2s ease;
}

.custom-select:hover {
  background-color: #e9ecef; /* Hover effect */
  border-color: #adb5bd;
}

.custom-select:focus {
  outline: none;
  border-color: #007bff;
  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
}

.custom-select-wrapper::after {
  content: '▼';
  font-size: 12px;
  color: #6c757d; /* Subtler arrow color */
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
}

.custom-select option {
  background-color: white;
  color: #333;
}

.custom-select option[value="add-new"] {
  font-style: italic;
  color: #007bff; /* Blue for 'Add New' */
}

body {
  margin: 0;
  font-family: 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: #f0f2f5;
  color: #333;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

.App {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

/* Buttons */
button {
  background-color: #007bff;
  color: white;
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 1em;
  transition: background-color 0.3s ease, transform 0.2s ease;
}

button:hover {
  background-color: #0056b3;
  transform: translateY(-1px);
}

button:active {
  transform: translateY(0);
}

/* Bulk Prepare Button */
.bulk-prepare-button {
  background: linear-gradient(135deg, #8e44ad 0%, #9b59b6 100%);
  color: white;
  padding: 10px 20px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(142, 68, 173, 0.2);
  display: flex;
  align-items: center;
  gap: 6px;
}

.bulk-prepare-button:hover {
  background: linear-gradient(135deg, #7d3c98 0%, #8e44ad 100%);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(142, 68, 173, 0.3);
}

.bulk-prepare-button:active {
  transform: translateY(0);
  box-shadow: 0 2px 6px rgba(142, 68, 173, 0.2);
}

/* ProjectListPage Styles */
.project-list-page-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px 20px;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
}

.project-list-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  max-width: 1200px;
  margin-bottom: 30px;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  padding: 20px 24px;
  border-radius: 12px;
  border: 1px solid #dee2e6;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.project-list-page-title {
  color: #2c3e50;
  margin: 0;
  font-size: 2.8em;
  font-weight: 700;
  text-align: left;
  flex: 1 1;
}

.download-db-button {
  background-color: #28a745;
  color: white;
  padding: 10px 15px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 0.9em;
  font-weight: 500;
  transition: background-color 0.2s ease;
}

.download-db-button:hover {
  background-color: #218838;
}

.upload-db-button {
  background-color: #007bff;
  color: white;
  padding: 10px 15px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 0.9em;
  font-weight: 500;
  transition: background-color 0.2s ease;
}

.upload-db-button:hover:not(:disabled) {
  background-color: #0056b3;
}

.upload-db-button:disabled {
  background-color: #6c757d;
  cursor: not-allowed;
}

.local-db-buttons {
  display: flex;
  gap: 10px;
  align-items: center;
}

.clear-db-button {
  background-color: #dc3545;
  color: white;
  padding: 10px 15px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 0.9em;
  font-weight: 500;
  transition: background-color 0.2s ease;
}

.clear-db-button:hover:not(:disabled) {
  background-color: #c82333;
}

.clear-db-button:disabled {
  background-color: #6c757d;
  cursor: not-allowed;
}

.sync-media-button {
  background-color: #17a2b8;
  color: white;
  padding: 10px 15px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 0.9em;
  font-weight: 500;
  transition: background-color 0.2s ease;
}

.sync-media-button:hover:not(:disabled) {
  background-color: #138496;
}

.sync-media-button:disabled {
  background-color: #6c757d;
  cursor: not-allowed;
}

.new-project-form {
  background-color: #ffffff;
  padding: 30px;
  border-radius: 10px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  gap: 15px;
  width: 100%;
  max-width: 600px;
  margin-bottom: 40px;
}

.new-project-form input,
.new-project-form textarea {
  padding: 12px;
  border: 1px solid #ced4da;
  border-radius: 5px;
  font-size: 1em;
  width: 100%;
  box-sizing: border-box;
}

.new-project-form input:focus,
.new-project-form textarea:focus {
  border-color: #007bff;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
  outline: none;
}

.new-project-form textarea {
  resize: vertical;
  min-height: 80px;
}

.create-project-button {
  background-color: #007bff;
}

.create-project-button:hover {
  background-color: #0056b3;
}

.project-list-section {
  width: 100%;
}

.no-projects-message {
  color: #6c757d;
  font-size: 1.1em;
  text-align: center;
  padding: 20px;
  background-color: #e9ecef;
  border-radius: 8px;
  margin-top: 20px;
}

.projects-horizontal-list {
  list-style: none;
  padding: 0;
  width: 100%;
}

.project-item-horizontal {
  background-color: #ffffff;
  padding: 15px 25px;
  border-radius: 10px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  margin-bottom: 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.project-item-horizontal:hover {
  transform: translateY(-3px);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);
}

.project-details-horizontal {
  flex-grow: 1;
}

.project-title-horizontal {
  color: #343a40;
  font-size: 1.3em;
  margin: 0 0 5px 0;
}

.project-description-horizontal {
  color: #6c757d;
  font-size: 0.9em;
  margin: 0 0 5px 0;
}

.project-date-horizontal {
  color: #999;
  font-size: 0.8em;
  margin: 0;
}

.project-actions-horizontal {
  display: flex;
  gap: 10px;
}

.edit-project-button {
  background-color: #007bff;
  color: white;
  padding: 8px 15px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 0.9em;
  transition: background-color 0.3s ease;
}

.edit-project-button:hover {
  background-color: #0056b3;
}

.delete-project-button {
  background-color: #dc3545;
  color: white;
  padding: 8px 15px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 0.9em;
  transition: background-color 0.3s ease;
}

.delete-project-button:hover {
  background-color: #c82333;
}

/* VideoEditorPage Styles */
.video-editor-page-container {
  display: flex;
  flex-direction: column;
  min-height: 100vh; /* Set min-height to allow content to expand */
  background-color: #f0f2f5;
}

.video-editor-header {
  background-color: #2c3e50;
  min-height: 70px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  color: white;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  flex-shrink: 0; /* Prevent header from shrinking */
}

.video-editor-header button {
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
  color: #495057;
  padding: 10px 16px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 0.9em;
  font-weight: 500;
  transition: all 0.2s ease;
  white-space: nowrap;
}

.video-editor-header button:hover {
  background-color: #e9ecef;
  border-color: #adb5bd;
  color: #343a40;
  transform: translateY(-1px);
}

.video-editor-main-content {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 30px 20px;
  gap: 30px;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
}

.video-section {
  width: 100%;
  background-color: #ffffff;
  padding: 25px;
  border-radius: 10px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
}

.video-upload-area {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
}

.file-input-button {
  padding: 12px 20px;
  border: 2px dashed #007bff;
  border-radius: 8px;
  background-color: #e9f5ff;
  color: #007bff;
  cursor: pointer;
  font-size: 1.1em;
  transition: all 0.3s ease;
}

.file-input-button:hover {
  background-color: #d0e9ff;
  border-color: #0056b3;
}

.video-player-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 15px;
}

.video-player-controls-top {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.reset-video-button {
  background-color: #dc3545;
}

.reset-video-button:hover {
  background-color: #c82333;
}

.video-player-wrapper-editor {
  width: 100%;
  position: relative;
  padding-top: 56.25%; /* 16:9 Aspect Ratio */
  background-color: #000;
  border-radius: 8px;
  overflow: hidden;
  margin-bottom: 10px;
}

.main-video-player {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.player-controls-editor {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 15px;
  margin-top: 20px;
  width: 100%;
}

.player-controls-editor p {
  margin: 0;
  font-size: 1.1em;
  color: #343a40;
}

.add-frame-button,
.add-clip-button,
.ai-analyze-button,
.add-intro-outro-button {
  background-color: #28a745;
}

.remove-vo-button {
  background-color: #dc3545;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
  font-size: 14px;
  transition: background-color 0.2s ease;
}

.remove-vo-button:hover {
  background-color: #c82333;
}

.add-frame-button:hover,
.add-clip-button:hover,
.ai-analyze-button:hover:not(:disabled),
.add-intro-outro-button:hover:not(:disabled) {
  background-color: #218838;
}

.timeline-controls {
  margin-bottom: 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 0;
  position: relative;
  height: 50px;
  min-height: 50px;
}

.timeline-controls-left {
  display: flex;
  gap: 0.5rem;
  align-items: center;
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
}

.timeline-controls-right {
  display: flex;
  gap: 0.5rem;
  align-items: center;
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  max-width: calc(100% - 200px);
}

.ai-analyze-button:disabled {
  background-color: #6c757d;
  cursor: not-allowed;
  opacity: 0.6;
}

.ai-analyze-button.generating {
  background-color: #ffc107;
  color: #212529;
}

.ai-analyze-button.generating:disabled {
  background-color: #ffc107;
  color: #212529;
  opacity: 0.8;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.ai-analyze-button.disabled {
  background-color: #6c757d;
  cursor: not-allowed;
  opacity: 0.6;
}

.timeline-section-editor {
  background-color: #ffffff;
  padding: 25px;
  border-radius: 10px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  width: 100%;
}

.timeline-section-editor h2 {
  color: #2c3e50;
  margin-bottom: 20px;
  font-size: 2em;
  font-weight: 600;
  text-align: center;
}

.empty-timeline-message {
  color: #6c757d;
  font-size: 1.1em;
  text-align: center;
  padding: 20px;
  background-color: #e9ecef;
  border-radius: 8px;
}

/* Timeline Component Styles */
.timeline-container {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

/* TimelineItem Component Styles */
.timeline-item {
  display: flex;
  flex-direction: column;
  background-color: #fdfdfd;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 15px;
  margin-bottom: 10px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);
  transition: all 0.2s ease-in-out;
}

.timeline-item:hover {
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  transform: translateY(-2px);
}

.timeline-item-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.timeline-item-controls {
  display: flex;
  gap: 5px;
}

.timeline-item-header strong {
  font-size: 1.1em;
  color: #333;
}

.remove-item-button {
  background-color: #dc3545;
  color: white;
  border: none;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  padding: 0;
  cursor: pointer;
  transition: background-color 0.2s ease;
  display: flex;
  justify-content: center;
  align-items: center;
}

.remove-item-button:hover {
  background-color: #c82333;
}

.remove-item-button svg {
  width: 16px;
  height: 16px;
  fill: white;
}

.remove-item-button:hover {
  background-color: #c82333;
}

.timeline-item-content {
  display: flex;
  flex-direction: row; /* Align items horizontally */
  gap: 15px; /* Space between thumbnail and textarea */
  align-items: flex-start; /* Align items to the top */
}

.timeline-media-container {
  width: 160px; /* Increased width for better visibility */
  height: 90px; 
  flex-shrink: 0; /* Prevent the thumbnail from shrinking */
  overflow: hidden;
  border-radius: 4px;
  border: 1px solid #ddd;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f0f0f0;
  position: relative; 
}

.timeline-media {
  width: 100%;
  height: 100%;
  object-fit: cover; 
}

.timeline-item-textarea {
  flex-grow: 1; /* Allow the textarea to take up remaining space */
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 0.9em;
  resize: vertical;
  min-height: 90px; /* Match the height of the thumbnail container */
}

.scene-description,
.scene-narration {
  margin-top: 10px;
  padding: 8px;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  background-color: #f9f9f9;
  font-size: 0.85em;
  text-align: left;
}

.scene-description strong,
.scene-narration strong {
  color: #555;
  margin-right: 5px;
}

.show-more-button {
  background-color: #6c757d;
  color: white;
  padding: 5px 10px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 0.8em;
  margin-top: 10px;
  align-self: flex-start;
}

.show-more-button:hover {
  background-color: #5a6268;
}

.timeline-item-accordion-content {
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px solid #eee;
  text-align: left;
}

.scene-description-edit,
.scene-narration-edit {
  margin-bottom: 10px;
}

.scene-description-edit label,
.scene-narration-edit label {
  display: block;
  font-weight: bold;
  margin-bottom: 5px;
  color: #333;
}

.scene-description-edit textarea,
.scene-narration-edit textarea {
  width: 100%;
  padding: 8px;
  border: 1px solid #ced4da;
  border-radius: 5px;
  font-size: 0.9em;
  resize: vertical;
  min-height: 60px;
}

.scene-audio-section {
  margin-bottom: 10px;
}

.scene-audio-section label {
  display: block;
  font-weight: bold;
  margin-bottom: 5px;
  color: #333;
}

.audio-controls-container {
  display: flex;
  align-items: center;
  gap: 10px;
}

.audio-player {
  flex: 1 1;
  margin-right: 10px;
}

.audio-player audio {
  width: 100%;
  max-width: 300px;
}

.audio-player p {
  margin: 0;
  color: #666;
  font-style: italic;
}

.regenerate-audio-button,
.regenerate-script-button {
  background-color: #007bff;
  color: white;
  border: none;
  padding: 8px 12px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.9em;
  white-space: nowrap;
  transition: background-color 0.2s ease;
}

.regenerate-audio-button:hover,
.regenerate-script-button:hover {
  background-color: #0056b3;
}

/* Voice Generation Dropdown Styles */
.voice-generation-dropdown {
  position: relative;
  display: inline-block;
}

.dropdown-toggle {
  display: flex;
  align-items: center;
  justify-content: center;
}

.voice-dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background-color: white;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  margin-top: 2px;
  min-width: 250px;
}

.voice-variation-option {
  width: 100%;
  padding: 12px 16px;
  border: none;
  background-color: transparent;
  text-align: left;
  cursor: pointer;
  transition: background-color 0.2s ease;
  border-bottom: 1px solid #eee;
}

.voice-variation-option:last-child {
  border-bottom: none;
}

.voice-variation-option:hover {
  background-color: #f8f9fa;
}

.variation-label {
  font-weight: bold;
  color: #333;
  margin-bottom: 4px;
}

.variation-description {
  font-size: 0.85em;
  color: #666;
  font-style: italic;
}

.regenerate-script-button {
  background-color: #28a745;
}

.regenerate-script-button:hover {
  background-color: #218838;
}


.frame-preview-button {
  position: absolute;
  bottom: 5px;
  right: 85px; /* Position before Edit Clip button */
  background-color: rgba(128, 0, 128, 0.8); /* Purple with transparency */
  color: white;
  border: none;
  border-radius: 4px;
  padding: 5px 8px;
  font-size: 0.8em;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.frame-preview-button:hover {
  background-color: #800080; /* Darker purple on hover */
}

.edit-clip-button {
  position: absolute;
  bottom: 5px;
  right: 5px;
  background-color: rgba(0, 123, 255, 0.8); /* Blue with transparency */
  color: white;
  border: none;
  border-radius: 4px;
  padding: 5px 8px;
  font-size: 0.8em;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.edit-clip-button:hover {
  background-color: #007bff;
}

.clip-editor-button {
  background-color: #6c757d;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 5px 8px;
  font-size: 0.8em;
  cursor: pointer;
  transition: background-color 0.2s ease;
  margin-right: 5px;
}

.clip-editor-button:hover {
  background-color: #5a6268;
}

/* Clip editor button color status indicators */
.clip-editor-button.clip-status-red {
  background-color: #dc3545; /* Red for clips edited in original version */
  border: 2px solid #dc3545;
}

.clip-editor-button.clip-status-red:hover {
  background-color: #c82333;
  border-color: #c82333;
}

.clip-editor-button.clip-status-green {
  background-color: #28a745; /* Green for clips edited in current language variant */
  border: 2px solid #28a745;
}

.clip-editor-button.clip-status-green:hover {
  background-color: #218838;
  border-color: #218838;
}

.clip-editor-button.clip-status-grey {
  background-color: #6c757d; /* Grey for no edits available */
  border: 2px solid #6c757d;
}

.clip-editor-button.clip-status-grey:hover {
  background-color: #5a6268;
  border-color: #5a6268;
}

/* Modal Styles (ConfirmationDialog and ClipEditModal) */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background-color: #ffffff;
  padding: 20px; /* Reduced padding */
  border-radius: 10px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
  text-align: center;
  max-width: 500px;
  width: 90%;
  animation: fadeIn 0.3s ease-out;
}

.modal-title {
  color: #2c3e50;
  font-size: 1.8em;
  margin: 0; /* Remove all margins */
}

.modal-message {
  color: #6c757d;
  font-size: 1.1em;
  margin-bottom: 25px;
  line-height: 1.5;
}

.modal-actions {
  display: flex;
  justify-content: center;
  gap: 15px;
}

.modal-confirm-button,
.modal-cancel-button {
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  font-size: 1em;
  cursor: pointer;
  transition: background-color 0.3s ease, transform 0.2s ease;
}

.modal-confirm-button {
  background-color: #dc3545; /* Red for delete */
  color: white;
}

.modal-confirm-button:hover {
  background-color: #c82333;
}

.modal-cancel-button {
  background-color: #6c757d; /* Grey for cancel */
  color: white;
}

.modal-cancel-button:hover {
  background-color: #5a6268;
}

/* Frame Preview Modal Specific Styles */
.frame-preview-modal {
  max-width: 800px !important;
  width: 90% !important;
}

.frame-info-section {
  background-color: #f8f9fa;
  padding: 15px;
  border-radius: 8px;
  margin-bottom: 20px;
  text-align: left;
}

.frame-info-section p {
  margin: 5px 0;
  color: #495057;
  font-size: 0.95em;
}

.frame-info-section strong {
  color: #2c3e50;
  font-weight: 600;
}

.frame-image-container {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f8f9fa;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 20px;
  min-height: 300px;
}

.frame-preview-image {
  max-width: 100%;
  max-height: 500px;
  border-radius: 8px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.15);
  object-fit: contain;
}

.no-annotation-message {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #6c757d;
  font-style: italic;
}

.no-annotation-message p {
  margin: 0;
  font-size: 1.1em;
}

@keyframes fadeIn {
  from { opacity: 0; transform: scale(0.9); }
  to { opacity: 1; transform: scale(1); }
}

/* Loading Overlay Styles */
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 2000; /* Higher than other modals */
  color: white;
  font-size: 1.2em;
}

.loading-spinner {
  border: 4px solid rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  border-top: 4px solid #007bff;
  width: 40px;
  height: 40px; /* Safari */
  animation: spin 1s linear infinite;
  margin-bottom: 15px;
}

/* Safari */

@keyframes spin {
  0% { transform: rotate(0deg); } 
  100% { transform: rotate(360deg); }
}

/* Message Popup Styles */
.message-popup {
  position: fixed;
  top: 20px;
  left: 50%;
  transform: translateX(-50%);
  padding: 15px 25px;
  border-radius: 8px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
  color: white;
  font-size: 1.1em;
  z-index: 2001; /* Even higher */
  display: flex;
  align-items: center;
  gap: 15px;
  animation: slideIn 0.5s ease-out;
}

.message-popup.success {
  background-color: #28a745; /* Green */
}

.message-popup.error {
  background-color: #dc3545; /* Red */
}

.message-popup p {
  margin: 0;
}

.message-popup button {
  background: none;
  border: 1px solid white;
  color: white;
  padding: 5px 10px;
  border-radius: 5px;
  cursor: pointer;
  font-size: 0.9em;
  transition: background-color 0.2s ease;
}

.message-popup button:hover {
  background-color: rgba(255, 255, 255, 0.2);
}

@keyframes slideIn {
  from { top: -50px; opacity: 0; }
  to { top: 20px; opacity: 1; }
}

/* ClipEditModal Specific Styles - Large Size */
.clip-edit-modal-large {
  background-color: #ffffff;
  padding: 15px 25px 25px 25px; /* Reduced top padding */
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  text-align: center;
  width: 80vw; /* 80% of screen width for optimal preview */
  max-width: 80vw; /* Ensure it doesn't exceed 80% */
  max-height: 95vh; /* 95% of viewport height for more space */
  overflow-y: auto; /* Add scroll if content overflows */
  position: relative; /* For proper positioning */
}

/* All child elements for large modal */
.clip-edit-modal-large .controls input[type="range"] {
  flex-grow: 1;
  appearance: none;
  height: 8px;
  background: #ddd;
  border-radius: 5px;
  outline: none;
  opacity: 0.7;
  transition: opacity .2s;
}

.clip-edit-modal-large .controls input[type="range"]::-webkit-slider-thumb {
  appearance: none;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: #007bff;
  cursor: pointer;
}

.clip-edit-modal-large .controls input[type="range"]::-moz-range-thumb {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: #007bff;
  cursor: pointer;
}

.clip-edit-modal-large .time-inputs {
  display: flex;
  justify-content: center;
  gap: 30px;
  margin-top: 10px;
  margin-bottom: 20px;
  padding: 20px;
  background: #ffffff;
  border: 1px solid #e9ecef;
  border-radius: 8px;
}

.clip-edit-modal-large .time-inputs label {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 1em;
}

.clip-edit-modal-large .time-inputs input[type="number"] {
  width: 80px;
  padding: 8px;
  border: 1px solid #ced4da;
  border-radius: 5px;
  font-size: 0.9em;
}

/* Compact Controls for ClipEditModal */
.clip-edit-modal-large .compact-controls {
  display: flex;
  align-items: center;
  gap: 15px;
  padding: 15px 20px;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-radius: 10px;
  margin: 15px 0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  flex-wrap: wrap;
}

.clip-edit-modal-large .control-btn {
  padding: 8px 16px;
  border: none;
  border-radius: 6px;
  font-size: 0.9rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  background: #007bff;
  color: white;
  box-shadow: 0 2px 4px rgba(0, 123, 255, 0.3);
}

.clip-edit-modal-large .control-btn:hover {
  background: #0056b3;
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 123, 255, 0.4);
}

.clip-edit-modal-large .capture-btn {
  background: #28a745;
  box-shadow: 0 2px 4px rgba(40, 167, 69, 0.3);
}

.clip-edit-modal-large .capture-btn:hover {
  background: #218838;
  box-shadow: 0 4px 8px rgba(40, 167, 69, 0.4);
}

.clip-edit-modal-large .capture-btn:disabled {
  background: #6c757d;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

.clip-edit-modal-large .time-display {
  font-size: 0.9rem;
  font-weight: 600;
  color: #495057;
  background: white;
  padding: 6px 12px;
  border-radius: 4px;
  border: 1px solid #dee2e6;
  min-width: 120px;
  text-align: center;
}

.clip-edit-modal-large .seek-slider {
  flex: 1 1;
  min-width: 200px;
  height: 6px;
  background: linear-gradient(to right, #007bff 0%, #dee2e6 0%);
  border-radius: 3px;
  outline: none;
  appearance: none;
}

.clip-edit-modal-large .seek-slider::-webkit-slider-thumb {
  appearance: none;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: #007bff;
  cursor: pointer;
  box-shadow: 0 2px 4px rgba(0, 123, 255, 0.3);
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}

.clip-edit-modal-large .seek-slider::-webkit-slider-thumb:hover {
  background: #0056b3;
  transform: scale(1.1);
  box-shadow: 0 3px 6px rgba(0, 123, 255, 0.4);
}

.clip-edit-modal-large .time-inputs-inline {
  display: flex;
  gap: 15px;
  align-items: center;
}

.clip-edit-modal-large .time-label {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 0.85rem;
  font-weight: 500;
  color: #495057;
}

.clip-edit-modal-large .time-input {
  width: 70px;
  padding: 6px 8px;
  border: 1px solid #ced4da;
  border-radius: 4px;
  font-size: 0.85rem;
  text-align: center;
  transition: border-color 0.2s ease;
}

.clip-edit-modal-large .time-input:focus {
  outline: none;
  border-color: #007bff;
  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
}

/* Legacy ClipEditModal class - keep for compatibility */
.clip-edit-modal {
  max-width: 90vw;
  width: 1200px;
  max-height: 90vh;
  overflow-y: auto;
}

.clip-edit-modal-large .player-wrapper,
.clip-edit-modal .player-wrapper {
  position: relative;
  height: 600px; /* Set a fixed height for better video preview */
  margin-bottom: 20px; /* Add some margin for spacing */
  border-radius: 8px;
  overflow: hidden;
  background: #000; /* Black background for video */
}

.clip-edit-modal-large .react-player,
.clip-edit-modal .react-player {
  position: absolute;
  top: 0;
  left: 0;
}

.clip-edit-modal-large .controls,
.clip-edit-modal .controls {
  display: flex;
  align-items: center;
  gap: 15px;
  margin-top: 10px; /* Add some margin */
  margin-bottom: 20px; /* Add bottom margin */
  padding: 15px; /* Add padding for better spacing */
  background: #f8f9fa; /* Light background for controls */
  border-radius: 8px;
}

.clip-edit-modal-large .controls button,
.clip-edit-modal .controls button {
  padding: 8px 15px;
  font-size: 0.9em;
}

.clip-edit-modal-large .controls span,
.clip-edit-modal .controls span {
  font-size: 1em;
  color: #555;
}

.clip-edit-modal .controls input[type="range"] {
  flex-grow: 1;
  appearance: none;
  height: 8px;
  background: #ddd;
  border-radius: 5px;
  outline: none;
  opacity: 0.7;
  transition: opacity .2s;
}

.clip-edit-modal .controls input[type="range"]::-webkit-slider-thumb {
  appearance: none;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: #007bff;
  cursor: pointer;
}

.clip-edit-modal .controls input[type="range"]::-moz-range-thumb {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: #007bff;
  cursor: pointer;
}

.clip-edit-modal .time-inputs {
  display: flex;
  justify-content: center;
  gap: 30px;
  margin-top: 10px; /* Add margin */
  margin-bottom: 20px; /* Add bottom margin */
  padding: 20px; /* Add padding */
  background: #ffffff;
  border: 1px solid #e9ecef;
  border-radius: 8px;
}

.clip-edit-modal .time-inputs label {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 1em;
}

.clip-edit-modal .time-inputs input[type="number"] {
  width: 80px;
  padding: 8px;
  border: 1px solid #ced4da;
  border-radius: 5px;
  font-size: 0.9em;
}

.advanced-edit-button {
  background-color: #007bff;
  color: white;
  padding: 8px 12px;
  border-radius: 5px;
  font-size: 0.9em;
  margin-right: 5px;
}

.advanced-edit-button:hover {
  background-color: #0056b3;
}

/* VideoCanvasPage Styles */
.video-canvas-page-container {
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
    background-color: #282c34;
    color: #ffffff;
    margin: 0;
    padding: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    min-height: 100vh;
}

.video-canvas-header {
    background-color: #2c3e50;
    min-height: 70px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 20px;
    color: white;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
    width: 100%;
    margin-bottom: 20px;
}

.video-canvas-header h1 {
    color: #61dafb;
    margin: 0;
}

.video-editor-main-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 15px;
    margin-bottom: 20px;
    width: 100%;
}

.editor-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 15px;
    margin-bottom: 20px;
}

#previewCanvas {
    border: 2px solid #61dafb;
    background-color: #000;
    max-width: 90vw; /* Responsive canvas */
}

#sourceVideo {
    /* We hide the source video; it's just for data and playback control */
    display: none;
}

.controls {
    display: flex;
    gap: 10px;
    align-items: center;
}

.controls button, .controls input[type="file"] {
    padding: 8px 12px;
    border-radius: 5px;
    border: 1px solid #61dafb;
    background-color: #3e4451;
    color: #ffffff;
    cursor: pointer;
    font-size: 14px;
}

.controls button:hover {
    background-color: #4f5766;
}

.controls button:disabled {
    background-color: #20232a;
    color: #777;
    cursor: not-allowed;
}

#timeline-container {
    width: 90vw;
    max-width: 800px;
    height: auto;
    background-color: #20232a;
    border-radius: 5px;
    padding: 10px;
    position: relative;
    overflow-x: auto;
    border: 1px solid #4f5766;
}

.track {
    position: relative;
    height: 40px;
    background-color: #3e4451;
    border-radius: 4px;
    margin-bottom: 8px;
    box-sizing: border-box;
}

.timeline-clip {
    position: absolute;
    top: 5px;
    height: 30px;
    background-color: #61dafb;
    border-radius: 4px;
    box-sizing: border-box;
    border: 1px solid #1a9fcc;
    cursor: move;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #000;
    font-size: 12px;
    font-weight: bold;
    overflow: hidden;
    white-space: nowrap;
}

.timeline-clip.video-clip {
    background-color: #fca311;
    border-color: #c9820e;
}

/* Resize Handles */
.timeline-clip::before,
.timeline-clip::after {
    content: '';
    position: absolute;
    top: 0;
    width: 8px;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    cursor: ew-resize; /* East-West resize cursor */
}
.timeline-clip::before {
    left: 0;
}
.timeline-clip::after {
    right: 0;
}

#downloadLinkContainer {
    margin-top: 20px;
}

/* YouTube Details Modal Styles */
.youtube-details-modal {
  max-width: 800px;
  width: 90%;
  max-height: 80vh;
  overflow-y: auto;
}

.youtube-details-content {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.youtube-detail-section {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.detail-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

.detail-header h3 {
  margin: 0;
  color: #333;
  font-size: 1.2em;
}

.copy-button {
  background-color: #007bff;
  color: white;
  border: none;
  padding: 6px 12px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.9em;
  transition: background-color 0.2s ease;
}

.copy-button:hover {
  background-color: #0056b3;
}

.youtube-title-textarea {
  width: 100%;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-family: Arial, sans-serif;
  font-size: 1em;
  resize: vertical;
  background-color: #f9f9f9;
}

.youtube-description-textarea {
  width: 100%;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-family: Arial, sans-serif;
  font-size: 0.9em;
  resize: vertical;
  background-color: #f9f9f9;
  line-height: 1.4;
}

.additional-prompt-textarea {
  width: 100%;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-family: Arial, sans-serif;
  font-size: 0.9em;
  resize: vertical;
  background-color: #ffffff;
  line-height: 1.4;
  border-color: #007bff;
  box-shadow: 0 0 0 1px rgba(0, 123, 255, 0.1);
}

.additional-prompt-textarea:focus {
  outline: none;
  border-color: #007bff;
  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
}

.additional-prompt-section {
  margin-bottom: 20px;
  padding: 15px;
  background-color: #f8f9fa;
  border-radius: 6px;
  border-left: 4px solid #007bff;
}

.modal-actions {
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid #eee;
}

.regenerate-button {
  background-color: #28a745;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 1em;
  transition: background-color 0.2s ease;
}

.regenerate-button:hover {
  background-color: #218838;
}

.close-button {
  background-color: #6c757d;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 1em;
  transition: background-color 0.2s ease;
}

.close-button:hover {
  background-color: #5a6268;
}

.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 15px;
  padding: 40px;
}

.error-message {
  text-align: center;
  color: #dc3545;
  padding: 20px;
}

.retry-button {
  background-color: #dc3545;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  margin-top: 10px;
  transition: background-color 0.2s ease;
}

.retry-button:hover {
  background-color: #c82333;
}

/* Capture Frame Button */
.capture-frame-button {
  background-color: #17a2b8;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.9em;
  transition: background-color 0.2s ease;
  margin-left: 10px;
}

.capture-frame-button:hover:not(:disabled) {
  background-color: #138496;
}

.capture-frame-button:disabled {
  background-color: #6c757d;
  cursor: not-allowed;
}

/* Edit Frame Button */
.edit-frame-button {
  background-color: #28a745;
  color: white;
  border: none;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  padding: 0;
  cursor: pointer;
  transition: background-color 0.2s ease;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 5px;
}

.edit-frame-button:hover {
  background-color: #218838;
}

.edit-frame-button svg {
  width: 16px;
  height: 16px;
  fill: white;
}

/* Frame Editor Modal Styles */
.frame-editor-modal {
  max-width: 95vw;
  width: 1200px;
  max-height: 95vh;
  overflow-y: auto;
}

.frame-editor-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 1px solid #eee;
}

.frame-editor-header h2 {
  margin: 0;
  color: #333;
  font-size: 1.4em;
}

.modal-close-button {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #666;
  padding: 0;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-close-button:hover {
  color: #333;
  background-color: #f0f0f0;
  border-radius: 50%;
}

.frame-editor-toolbar {
  display: flex;
  align-items: center;
  gap: 20px;
  padding: 15px;
  background-color: #f8f9fa;
  border-radius: 8px;
  margin-bottom: 20px;
  flex-wrap: wrap;
}

.tool-group {
  display: flex;
  gap: 8px;
}

.tool-button {
  background-color: #fff;
  border: 1px solid #ddd;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.9em;
  transition: all 0.2s ease;
}

.tool-button:hover {
  background-color: #e9ecef;
  border-color: #adb5bd;
}

.tool-button.active {
  background-color: #007bff;
  color: white;
  border-color: #007bff;
}

.color-group {
  display: flex;
  align-items: center;
  gap: 8px;
}

.color-picker {
  width: 40px;
  height: 40px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.text-group {
  display: flex;
  align-items: center;
  gap: 8px;
}

.text-input {
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 0.9em;
  width: 150px;
}

.action-group {
  display: flex;
  gap: 8px;
}

.action-button {
  background-color: #6c757d;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.9em;
  transition: background-color 0.2s ease;
}

.action-button:hover:not(:disabled) {
  background-color: #5a6268;
}

.action-button:disabled {
  background-color: #e9ecef;
  color: #6c757d;
  cursor: not-allowed;
}

.action-button.delete {
  background-color: #dc3545;
}

.action-button.delete:hover:not(:disabled) {
  background-color: #c82333;
}

.canvas-container {
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
  padding: 20px;
  background-color: #f0f0f0;
  border-radius: 8px;
  overflow: auto;
}

.frame-editor-actions {
  display: flex;
  justify-content: space-between;
  gap: 10px;
  padding-top: 20px;
  border-top: 1px solid #eee;
}

.export-button {
  background-color: #28a745;
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 1em;
  transition: background-color 0.2s ease;
}

.export-button:hover {
  background-color: #218838;
}

.reset-button {
  background-color: #ffc107;
  color: #212529;
  border: none;
  padding: 12px 24px;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 500;
  transition: background-color 0.2s ease;
  display: flex;
  align-items: center;
  gap: 8px;
}

.reset-button:hover {
  background-color: #e0a800;
}

/* Reset Confirmation Modal Styles */
.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 1px solid #eee;
}

.modal-header h3 {
  margin: 0;
  color: #333;
  font-size: 1.2em;
}

.modal-close {
  background: none;
  border: none;
  cursor: pointer;
  color: #666;
  padding: 5px;
  border-radius: 3px;
  transition: background-color 0.2s;
}

.modal-close:hover {
  background-color: #f5f5f5;
}

.modal-body {
  margin-bottom: 20px;
  text-align: left;
}

.modal-body p {
  margin: 0 0 10px 0;
  color: #333;
  line-height: 1.4;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.modal-button {
  padding: 10px 20px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 500;
  transition: background-color 0.2s;
}

.modal-button.cancel {
  background-color: #6c757d;
  color: white;
}

.modal-button.cancel:hover {
  background-color: #5a6268;
}

.modal-button.confirm {
  background-color: #dc3545;
  color: white;
}

.modal-button.confirm:hover {
  background-color: #c82333;
}

/* Inline Duration Controls (in playback toolbar) */
.time-display-container {
  display: flex;
  align-items: center;
  gap: 20px;
}

.duration-control-inline {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  background: #1a1a1a;
  border: 1px solid #444;
  border-radius: 6px;
}

.duration-input-inline {
  width: 60px;
  background: transparent;
  border: none;
  color: #fff;
  font-size: 0.85em;
  text-align: center;
  padding: 2px 4px;
}

.duration-input-inline:focus {
  outline: none;
  background: #2a2a2a;
  border-radius: 3px;
}

.duration-unit-inline {
  color: #aaa;
  font-size: 0.8em;
  font-weight: 500;
}

.duration-reset-inline {
  background: none;
  border: none;
  color: #aaa;
  cursor: pointer;
  padding: 2px;
  border-radius: 3px;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.duration-reset-inline:hover {
  color: #fff;
  background: #444;
}

/* Videos Project Button */
.videos-project-button {
  background-color: #17a2b8;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.9em;
  font-weight: 500;
  transition: background-color 0.2s ease;
}

.videos-project-button:hover {
  background-color: #138496;
}

/* Project Videos Page Styles */
.project-videos-page {
  min-height: 100vh;
  background-color: #1a1a1a;
  color: #fff;
}

.project-videos-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 2rem;
  background: #2a2a2a;
  border-bottom: 1px solid #444;
}

.header-content h1 {
  margin: 0 0 0.5rem 0;
  color: #fff;
  font-size: 1.8rem;
}

.project-description {
  margin: 0;
  color: #aaa;
  font-size: 0.9rem;
}

.header-actions {
  display: flex;
  gap: 1rem;
}

.back-button, .edit-button, .sync-media-button {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1.5rem;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 500;
  transition: background-color 0.2s;
  text-decoration: none;
}

.back-button {
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
  color: #495057;
}

.back-button:hover {
  background-color: #e9ecef;
  border-color: #adb5bd;
  color: #343a40;
  transform: translateY(-1px);
}

.edit-button {
  background-color: #007bff;
  color: white;
}

.edit-button:hover {
  background-color: #0056b3;
}

.sync-media-button {
  background-color: #28a745;
  color: white;
}

.sync-media-button:hover:not(:disabled) {
  background-color: #218838;
}

.sync-media-button:disabled {
  background-color: #6c757d;
  cursor: not-allowed;
  opacity: 0.6;
}

.sync-media-button.syncing {
  background-color: #fd7e14;
}

.sync-media-button.syncing svg {
  animation: rotate 1s linear infinite;
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.project-videos-main {
  padding: 2rem;
}

.loading-container, .error-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 50vh;
  text-align: center;
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #444;
  border-top: 4px solid #007bff;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 1rem;
}

.no-videos-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 50vh;
  text-align: center;
}

.no-videos-icon {
  color: #666;
  margin-bottom: 1rem;
}

.no-videos-container h2 {
  color: #fff;
  margin-bottom: 0.5rem;
}

.no-videos-container p {
  color: #aaa;
  margin-bottom: 2rem;
}

.create-video-button {
  background-color: #28a745;
  color: white;
  border: none;
  padding: 1rem 2rem;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 500;
  transition: background-color 0.2s;
}

.create-video-button:hover {
  background-color: #218838;
}

.videos-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(400px, 1fr));
  gap: 1.5rem;
}

.video-card {
  background: #2a2a2a;
  border: 1px solid #444;
  border-radius: 8px;
  padding: 1.5rem;
  transition: all 0.2s ease;
}

.video-card:hover {
  border-color: #666;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
}

.video-info {
  display: flex;
  align-items: flex-start;
  gap: 1rem;
  margin-bottom: 1rem;
}

.video-icon {
  color: #007bff;
  flex-shrink: 0;
}

.video-details {
  flex: 1 1;
  min-width: 0;
}

.video-name {
  margin: 0 0 0.5rem 0;
  color: #fff;
  font-size: 1rem;
  font-weight: 600;
  word-break: break-all;
}

.video-metadata {
  margin: 0;
  color: #aaa;
  font-size: 0.85rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.separator {
  color: #666;
}

.video-actions {
  display: flex;
  gap: 0.75rem;
}

.download-button, .delete-button {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.85rem;
  font-weight: 500;
  transition: background-color 0.2s;
}

.download-button {
  background-color: #28a745;
  color: white;
}

.download-button:hover {
  background-color: #218838;
}

.delete-button {
  background-color: #dc3545;
  color: white;
}

.delete-button:hover {
  background-color: #c82333;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* Header buttons container */
.header-buttons {
  display: flex;
  gap: 10px;
  align-items: center;
}

/* Header Actions Container */
.header-actions {
  display: flex;
  align-items: center;
  gap: 12px;
}

/* DB Operations Dropdown */
.db-dropdown {
  position: relative;
  display: inline-block;
}

.db-operations-button {
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
  color: #495057;
  padding: 10px 16px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 0.9em;
  font-weight: 500;
  transition: all 0.2s ease;
  white-space: nowrap;
}

.db-operations-button:hover {
  background-color: #e9ecef;
  border-color: #adb5bd;
  color: #343a40;
  transform: translateY(-1px);
}


.db-dropdown-content {
  position: absolute;
  right: 0;
  top: 100%;
  min-width: 180px;
  background-color: white;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  z-index: 1000;
  overflow: hidden;
  margin-top: 4px;
}

.db-dropdown-item {
  display: block;
  width: 100%;
  padding: 12px 16px;
  border: none;
  background: none;
  text-align: left;
  cursor: pointer;
  font-size: 14px;
  color: #333;
  transition: background-color 0.2s ease;
  white-space: nowrap;
}

.db-dropdown-item:hover:not(:disabled) {
  background-color: #f5f5f5;
}

.db-dropdown-item:disabled {
  color: #999;
  cursor: not-allowed;
  opacity: 0.6;
}

.db-dropdown-item + .db-dropdown-item {
  border-top: 1px solid #f0f0f0;
}

/* Settings Button */
.settings-button {
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
  color: #495057;
  font-size: 0.9em;
  cursor: pointer;
  padding: 10px 16px;
  border-radius: 6px;
  transition: all 0.2s ease;
  font-weight: 500;
  white-space: nowrap;
}

.settings-button:hover {
  background-color: #e9ecef;
  border-color: #adb5bd;
  color: #343a40;
  transform: translateY(-1px);
}

/* Logout Button */
.logout-button {
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
  color: #495057;
  font-size: 0.9em;
  cursor: pointer;
  padding: 10px 16px;
  border-radius: 6px;
  transition: all 0.2s ease;
  font-weight: 500;
  white-space: nowrap;
}

.logout-button:hover {
  background-color: #e9ecef;
  border-color: #adb5bd;
  color: #343a40;
  transform: translateY(-1px);
}

/* YouTube Linking button styling */
.youtube-linking-button {
  background: linear-gradient(135deg, #FF0000 0%, #CC0000 100%);
  color: white;
  border: none;
  padding: 10px 16px;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 600;
  font-size: 14px;
  transition: all 0.2s ease;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  gap: 5px;
}

.youtube-linking-button:hover {
  background: linear-gradient(135deg, #CC0000 0%, #990000 100%);
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(255, 0, 0, 0.3);
}


/* Master Project Styles */
.create-master-project-button {
  background-color: #28a745;
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 6px;
  font-size: 1rem;
  cursor: pointer;
  margin-bottom: 20px;
  font-weight: 500;
  transition: background-color 0.2s;
}
.create-master-project-button:hover {
  background-color: #218838;
}

.master-project-actions {
  width: 100%;
  max-width: 1200px;
  display: flex;
  justify-content: flex-start;
  margin-bottom: 10px;
}

.master-projects-section {
  width: 100%;
  max-width: 1200px;
}

/* Loading state for master projects */
.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  text-align: center;
  min-height: 200px;
}

.loading-container .loading-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #007bff;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 20px;
}

.loading-container p {
  color: #6c757d;
  font-size: 1rem;
  margin: 0;
}

/* Master Project Controls (Search + Create Button) */
.master-project-controls {
  width: 100%;
  max-width: 1200px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
  margin-bottom: 20px;
}

.search-container {
  flex: 1 1;
  max-width: 400px;
}

.search-input {
  width: 100%;
  padding: 12px 16px;
  border: 1px solid #ced4da;
  border-radius: 6px;
  font-size: 1rem;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.search-input:focus {
  outline: none;
  border-color: #007bff;
  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
}

.search-input::placeholder {
  color: #6c757d;
}

/* Pagination Styles */
.pagination-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  margin-top: 30px;
  padding: 20px;
  background: #f8f9fa;
  border-radius: 8px;
  border: 1px solid #e9ecef;
}

.pagination-info {
  font-size: 0.9rem;
  color: #6c757d;
  font-weight: 500;
}

.pagination-controls {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.pagination-button {
  background-color: #ffffff;
  border: 1px solid #dee2e6;
  color: #495057;
  padding: 8px 12px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.9rem;
  transition: all 0.2s ease;
  min-width: 40px;
  text-align: center;
}

.pagination-button:hover:not(:disabled) {
  background-color: #e9ecef;
  border-color: #adb5bd;
}

.pagination-button:disabled {
  background-color: #f8f9fa;
  border-color: #e9ecef;
  color: #adb5bd;
  cursor: not-allowed;
}

.pagination-button.active {
  background-color: #007bff;
  border-color: #007bff;
  color: white;
}

.pagination-button.active:hover {
  background-color: #0056b3;
  border-color: #0056b3;
}

/* Final Videos Button */
.final-videos-button {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 20px;
  background: #6c757d;
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  text-decoration: none;
  transition: all 0.2s ease;
  margin-right: 10px;
  box-shadow: 0 2px 4px rgba(108, 117, 125, 0.3);
}

.final-videos-button:hover {
  background: #5a6268;
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(108, 117, 125, 0.4);
}

.final-videos-button svg {
  flex-shrink: 0;
}

/* Read-only textarea styling for localhost */
textarea[readonly] {
  background-color: #f8f9fa !important;
  color: #6c757d !important;
  cursor: not-allowed !important;
  opacity: 0.8;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .master-project-controls {
    flex-direction: column;
    align-items: stretch;
    gap: 16px;
  }

  .search-container {
    max-width: none;
  }

  .pagination-controls {
    justify-content: center;
  }

  .pagination-button {
    padding: 10px 14px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,YAAY;;AAEZ;EACE,WAAW;EACX,aAAa;EACb,8BAA8B,EAAE,4BAA4B;EAC5D,mBAAmB,EAAE,2BAA2B;EAChD,mBAAmB,EAAE,yBAAyB;AAChD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc,EAAE,gCAAgC;EAChD,WAAW,EAAE,uCAAuC;AACtD;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EAGE,gBAAgB;EAChB,yBAAyB,EAAE,uBAAuB;EAClD,yBAAyB,EAAE,oBAAoB;EAC/C,kBAAkB;EAClB,WAAW,EAAE,gBAAgB;EAC7B,0BAA0B;EAC1B,cAAc;EACd,eAAe;EACf,8DAA8D;AAChE;;AAEA;EACE,yBAAyB,EAAE,iBAAiB;EAC5C,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,cAAc,EAAE,wBAAwB;EACxC,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,cAAc,EAAE,uBAAuB;AACzC;;AAEA;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;EAClC,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE;aACW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA,YAAY;AACZ;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,2DAA2D;AAC7D;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,wBAAwB;AACxB;EACE,6DAA6D;EAC7D,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,6CAA6C;EAC7C,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,6DAA6D;EAC7D,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,wBAAwB;EACxB,6CAA6C;AAC/C;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,6DAA6D;EAC7D,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,SAAS;EACT,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,SAAO;AACT;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,yCAAyC;EACzC,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,sBAAsB;AACxB;;AAEA;;EAEE,qBAAqB;EACrB,gDAAgD;EAChD,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,0CAA0C;EAC1C,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB,EAAE,8CAA8C;EACjE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,YAAY;EACZ,wCAAwC;EACxC,cAAc,EAAE,kCAAkC;AACpD;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,yCAAyC;EACzC,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB,EAAE,sBAAsB;EAC3C,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;;;EAIE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;;EAIE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,UAAU;EACV,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,QAAQ;EACR,QAAQ;EACR,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,yCAAyC;EACzC,WAAW;AACb;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,kCAAkC;AAClC;EACE,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,yCAAyC;EACzC,gCAAgC;AAClC;;AAEA;EACE,yCAAyC;EACzC,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,eAAe;EACf,sCAAsC;EACtC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB,EAAE,6BAA6B;EAClD,SAAS,EAAE,yCAAyC;EACpD,uBAAuB,EAAE,2BAA2B;AACtD;;AAEA;EACE,YAAY,EAAE,0CAA0C;EACxD,YAAY;EACZ,cAAc,EAAE,yCAAyC;EACzD,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,YAAY,EAAE,kDAAkD;EAChE,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB,EAAE,gDAAgD;AACpE;;AAEA;;EAEE,gBAAgB;EAChB,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;EAEE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;AACb;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,SAAO;EACP,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,kBAAkB;AACpB;;AAEA;;EAEE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA,qCAAqC;AACrC;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;EAClB,wCAAwC;EACxC,aAAa;EACb,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,6BAA6B;EAC7B,gBAAgB;EAChB,eAAe;EACf,sCAAsC;EACtC,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;;AAGA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW,EAAE,qCAAqC;EAClD,wCAAwC,EAAE,6BAA6B;EACvE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB,EAAE,2BAA2B;AACxD;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,wCAAwC,EAAE,2BAA2B;EACrE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,sCAAsC;EACtC,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,+CAA+C;AAC/C;EACE,yBAAyB,EAAE,6CAA6C;EACxE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB,EAAE,uDAAuD;EAClF,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB,EAAE,gCAAgC;EAC3D,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,wDAAwD;AACxD;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,aAAa,EAAE,oBAAoB;EACnC,mBAAmB;EACnB,yCAAyC;EACzC,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;EACV,+BAA+B;AACjC;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,SAAS,EAAE,uBAAuB;AACpC;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;;EAEE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,2DAA2D;AAC7D;;AAEA;EACE,yBAAyB,EAAE,mBAAmB;EAC9C,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB,EAAE,oBAAoB;EAC/C,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,wCAAwC;AACxC;EACE,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,OAAO,UAAU,EAAE,qBAAqB,EAAE;EAC1C,KAAK,UAAU,EAAE,mBAAmB,EAAE;AACxC;;AAEA,2BAA2B;AAC3B;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa,EAAE,6BAA6B;EAC5C,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,0CAA0C;EAC1C,kBAAkB;EAClB,6BAA6B;EAC7B,WAAW;EACX,YAAY,EACgC,WAAW;EACvD,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA,WAAW;;AAMX;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA,yBAAyB;AACzB;EACE,eAAe;EACf,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,kBAAkB;EAClB,kBAAkB;EAClB,yCAAyC;EACzC,YAAY;EACZ,gBAAgB;EAChB,aAAa,EAAE,gBAAgB;EAC/B,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE,yBAAyB,EAAE,UAAU;AACvC;;AAEA;EACE,yBAAyB,EAAE,QAAQ;AACrC;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,OAAO,UAAU,EAAE,UAAU,EAAE;EAC/B,KAAK,SAAS,EAAE,UAAU,EAAE;AAC9B;;AAEA,+CAA+C;AAC/C;EACE,yBAAyB;EACzB,4BAA4B,EAAE,wBAAwB;EACtD,mBAAmB;EACnB,yCAAyC;EACzC,kBAAkB;EAClB,WAAW,EAAE,4CAA4C;EACzD,eAAe,EAAE,iCAAiC;EAClD,gBAAgB,EAAE,0CAA0C;EAC5D,gBAAgB,EAAE,oCAAoC;EACtD,kBAAkB,EAAE,2BAA2B;AACjD;;AAEA,uCAAuC;AACvC;EACE,YAAY;EAEZ,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EAEE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,uCAAuC;AACvC;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,6DAA6D;EAC7D,mBAAmB;EACnB,cAAc;EACd,wCAAwC;EACxC,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;EACZ,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,WAAW;EACX,6DAA6D;EAC7D,kBAAkB;EAClB,aAAa;EAEb,gBAAgB;AAClB;;AAEA;EAEE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,4CAA4C;EAC5C,iCAAyB;EAAzB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA,wDAAwD;AACxD;EACE,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;EAClB,aAAa,EAAE,gDAAgD;EAC/D,mBAAmB,EAAE,gCAAgC;EACrD,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB,EAAE,+BAA+B;AACnD;;AAEA;;EAEE,kBAAkB;EAClB,MAAM;EACN,OAAO;AACT;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB,EAAE,oBAAoB;EACtC,mBAAmB,EAAE,sBAAsB;EAC3C,aAAa,EAAE,mCAAmC;EAClD,mBAAmB,EAAE,kCAAkC;EACvD,kBAAkB;AACpB;;AAEA;;EAEE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,YAAY;EAEZ,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EAEE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,gBAAgB,EAAE,eAAe;EACjC,mBAAmB,EAAE,sBAAsB;EAC3C,aAAa,EAAE,gBAAgB;EAC/B,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,2BAA2B;AAC3B;IACI,gGAAgG;IAChG,yBAAyB;IACzB,cAAc;IACd,SAAS;IACT,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;IACf,YAAY;IACZ,wCAAwC;IACxC,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;IACT,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,sBAAsB;IACtB,eAAe,EAAE,sBAAsB;AAC3C;;AAEA;IACI,sEAAsE;IACtE,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,yBAAyB;IACzB,yBAAyB;IACzB,cAAc;IACd,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,sBAAsB;IACtB,yBAAyB;IACzB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA,mBAAmB;AACnB;;IAEI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,UAAU;IACV,YAAY;IACZ,oCAAoC;IACpC,iBAAiB,EAAE,4BAA4B;AACnD;AACA;IACI,OAAO;AACX;AACA;IACI,QAAQ;AACZ;;AAEA;IACI,gBAAgB;AACpB;;AAEA,iCAAiC;AACjC;EACE,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,8BAA8B;EAC9B,cAAc;EACd,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,8BAA8B;EAC9B,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,8BAA8B;EAC9B,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;EAChB,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,yBAAyB;AACzB;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,sCAAsC;EACtC,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,eAAe;EACf,sCAAsC;EACtC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,WAAW;AACb;;AAEA,8BAA8B;AAC9B;EACE,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;EACE,SAAS;EACT,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,WAAW;EACX,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,sCAAsC;EACtC,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;EACE,SAAS;EACT,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,mDAAmD;AACnD;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA,0BAA0B;AAC1B;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,+BAA+B;AAC/B;EACE,iBAAiB;EACjB,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iCAAiC;EACjC,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,oBAAoB;EACpB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA,2BAA2B;AAC3B;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,2BAA2B;AAC7B;;;AAGA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gBAAgB;EAChB,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,0CAA0C;EAC1C,aAAa;EACb,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,WAAW;EACX,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,6BAA6B;AAC/B;;AAEA,oBAAoB;AACpB;EACE,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,2BAA2B;AAC7B;;AAEA,kBAAkB;AAClB;EACE,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,2BAA2B;AAC7B;;AAEA,mCAAmC;AACnC;EACE,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,6DAA6D;EAC7D,2BAA2B;EAC3B,0CAA0C;AAC5C;;;AAGA,0BAA0B;AAC1B;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,iCAAiC;AACnC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA,sCAAsC;AACtC;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,SAAS;AACX;;AAEA,qDAAqD;AACrD;EACE,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,wDAAwD;AAC1D;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,yBAAyB;EACzB,kBAAkB;EAClB,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,cAAc;AAChB;;AAEA,6CAA6C;AAC7C;EACE,oCAAoC;EACpC,yBAAyB;EACzB,8BAA8B;EAC9B,YAAY;AACd;;AAEA,2BAA2B;AAC3B;EACE;IACE,sBAAsB;IACtB,oBAAoB;IACpB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;EACpB;AACF","sourcesContent":["/* App.css */\n\n.video-player-controls-top {\n  width: 100%;\n  display: flex;\n  justify-content: space-between; /* Change to space-between */\n  align-items: center; /* Vertically align items */\n  margin-bottom: 10px; /* Add some space below */\n}\n\n.language-selector-top {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 1em; /* Increase font size slightly */\n  color: #333; /* Darker text for better readability */\n}\n\n.custom-select-wrapper {\n  position: relative;\n  display: inline-block;\n}\n\n.custom-select {\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  background-color: #f8f9fa; /* Lighter background */\n  border: 1px solid #ced4da; /* Standard border */\n  border-radius: 5px;\n  color: #333; /* Darker text */\n  padding: 8px 30px 8px 12px;\n  font-size: 1em;\n  cursor: pointer;\n  transition: background-color 0.2s ease, border-color 0.2s ease;\n}\n\n.custom-select:hover {\n  background-color: #e9ecef; /* Hover effect */\n  border-color: #adb5bd;\n}\n\n.custom-select:focus {\n  outline: none;\n  border-color: #007bff;\n  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);\n}\n\n.custom-select-wrapper::after {\n  content: '▼';\n  font-size: 12px;\n  color: #6c757d; /* Subtler arrow color */\n  position: absolute;\n  right: 10px;\n  top: 50%;\n  transform: translateY(-50%);\n  pointer-events: none;\n}\n\n.custom-select option {\n  background-color: white;\n  color: #333;\n}\n\n.custom-select option[value=\"add-new\"] {\n  font-style: italic;\n  color: #007bff; /* Blue for 'Add New' */\n}\n\nbody {\n  margin: 0;\n  font-family: 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  background-color: #f0f2f5;\n  color: #333;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\n.App {\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh;\n}\n\n/* Buttons */\nbutton {\n  background-color: #007bff;\n  color: white;\n  padding: 10px 20px;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  font-size: 1em;\n  transition: background-color 0.3s ease, transform 0.2s ease;\n}\n\nbutton:hover {\n  background-color: #0056b3;\n  transform: translateY(-1px);\n}\n\nbutton:active {\n  transform: translateY(0);\n}\n\n/* Bulk Prepare Button */\n.bulk-prepare-button {\n  background: linear-gradient(135deg, #8e44ad 0%, #9b59b6 100%);\n  color: white;\n  padding: 10px 20px;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n  transition: all 0.3s ease;\n  box-shadow: 0 2px 8px rgba(142, 68, 173, 0.2);\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.bulk-prepare-button:hover {\n  background: linear-gradient(135deg, #7d3c98 0%, #8e44ad 100%);\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(142, 68, 173, 0.3);\n}\n\n.bulk-prepare-button:active {\n  transform: translateY(0);\n  box-shadow: 0 2px 6px rgba(142, 68, 173, 0.2);\n}\n\n/* ProjectListPage Styles */\n.project-list-page-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 40px 20px;\n  width: 100%;\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.project-list-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  max-width: 1200px;\n  margin-bottom: 30px;\n  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);\n  padding: 20px 24px;\n  border-radius: 12px;\n  border: 1px solid #dee2e6;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n}\n\n.project-list-page-title {\n  color: #2c3e50;\n  margin: 0;\n  font-size: 2.8em;\n  font-weight: 700;\n  text-align: left;\n  flex: 1;\n}\n\n.download-db-button {\n  background-color: #28a745;\n  color: white;\n  padding: 10px 15px;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  font-size: 0.9em;\n  font-weight: 500;\n  transition: background-color 0.2s ease;\n}\n\n.download-db-button:hover {\n  background-color: #218838;\n}\n\n.upload-db-button {\n  background-color: #007bff;\n  color: white;\n  padding: 10px 15px;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  font-size: 0.9em;\n  font-weight: 500;\n  transition: background-color 0.2s ease;\n}\n\n.upload-db-button:hover:not(:disabled) {\n  background-color: #0056b3;\n}\n\n.upload-db-button:disabled {\n  background-color: #6c757d;\n  cursor: not-allowed;\n}\n\n.local-db-buttons {\n  display: flex;\n  gap: 10px;\n  align-items: center;\n}\n\n.clear-db-button {\n  background-color: #dc3545;\n  color: white;\n  padding: 10px 15px;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  font-size: 0.9em;\n  font-weight: 500;\n  transition: background-color 0.2s ease;\n}\n\n.clear-db-button:hover:not(:disabled) {\n  background-color: #c82333;\n}\n\n.clear-db-button:disabled {\n  background-color: #6c757d;\n  cursor: not-allowed;\n}\n\n.sync-media-button {\n  background-color: #17a2b8;\n  color: white;\n  padding: 10px 15px;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  font-size: 0.9em;\n  font-weight: 500;\n  transition: background-color 0.2s ease;\n}\n\n.sync-media-button:hover:not(:disabled) {\n  background-color: #138496;\n}\n\n.sync-media-button:disabled {\n  background-color: #6c757d;\n  cursor: not-allowed;\n}\n\n.new-project-form {\n  background-color: #ffffff;\n  padding: 30px;\n  border-radius: 10px;\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n  width: 100%;\n  max-width: 600px;\n  margin-bottom: 40px;\n}\n\n.new-project-form input,\n.new-project-form textarea {\n  padding: 12px;\n  border: 1px solid #ced4da;\n  border-radius: 5px;\n  font-size: 1em;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.new-project-form input:focus,\n.new-project-form textarea:focus {\n  border-color: #007bff;\n  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);\n  outline: none;\n}\n\n.new-project-form textarea {\n  resize: vertical;\n  min-height: 80px;\n}\n\n.create-project-button {\n  background-color: #007bff;\n}\n\n.create-project-button:hover {\n  background-color: #0056b3;\n}\n\n.project-list-section {\n  width: 100%;\n}\n\n.no-projects-message {\n  color: #6c757d;\n  font-size: 1.1em;\n  text-align: center;\n  padding: 20px;\n  background-color: #e9ecef;\n  border-radius: 8px;\n  margin-top: 20px;\n}\n\n.projects-horizontal-list {\n  list-style: none;\n  padding: 0;\n  width: 100%;\n}\n\n.project-item-horizontal {\n  background-color: #ffffff;\n  padding: 15px 25px;\n  border-radius: 10px;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);\n  margin-bottom: 15px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\n}\n\n.project-item-horizontal:hover {\n  transform: translateY(-3px);\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);\n}\n\n.project-details-horizontal {\n  flex-grow: 1;\n}\n\n.project-title-horizontal {\n  color: #343a40;\n  font-size: 1.3em;\n  margin: 0 0 5px 0;\n}\n\n.project-description-horizontal {\n  color: #6c757d;\n  font-size: 0.9em;\n  margin: 0 0 5px 0;\n}\n\n.project-date-horizontal {\n  color: #999;\n  font-size: 0.8em;\n  margin: 0;\n}\n\n.project-actions-horizontal {\n  display: flex;\n  gap: 10px;\n}\n\n.edit-project-button {\n  background-color: #007bff;\n  color: white;\n  padding: 8px 15px;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  font-size: 0.9em;\n  transition: background-color 0.3s ease;\n}\n\n.edit-project-button:hover {\n  background-color: #0056b3;\n}\n\n.delete-project-button {\n  background-color: #dc3545;\n  color: white;\n  padding: 8px 15px;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  font-size: 0.9em;\n  transition: background-color 0.3s ease;\n}\n\n.delete-project-button:hover {\n  background-color: #c82333;\n}\n\n/* VideoEditorPage Styles */\n.video-editor-page-container {\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh; /* Set min-height to allow content to expand */\n  background-color: #f0f2f5;\n}\n\n.video-editor-header {\n  background-color: #2c3e50;\n  min-height: 70px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 20px;\n  color: white;\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\n  flex-shrink: 0; /* Prevent header from shrinking */\n}\n\n.video-editor-header button {\n  background-color: #f8f9fa;\n  border: 1px solid #dee2e6;\n  color: #495057;\n  padding: 10px 16px;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 0.9em;\n  font-weight: 500;\n  transition: all 0.2s ease;\n  white-space: nowrap;\n}\n\n.video-editor-header button:hover {\n  background-color: #e9ecef;\n  border-color: #adb5bd;\n  color: #343a40;\n  transform: translateY(-1px);\n}\n\n.video-editor-main-content {\n  flex-grow: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 30px 20px;\n  gap: 30px;\n  width: 100%;\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.video-section {\n  width: 100%;\n  background-color: #ffffff;\n  padding: 25px;\n  border-radius: 10px;\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 20px;\n}\n\n.video-upload-area {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 20px;\n}\n\n.file-input-button {\n  padding: 12px 20px;\n  border: 2px dashed #007bff;\n  border-radius: 8px;\n  background-color: #e9f5ff;\n  color: #007bff;\n  cursor: pointer;\n  font-size: 1.1em;\n  transition: all 0.3s ease;\n}\n\n.file-input-button:hover {\n  background-color: #d0e9ff;\n  border-color: #0056b3;\n}\n\n.video-player-container {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 15px;\n}\n\n.video-player-controls-top {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.reset-video-button {\n  background-color: #dc3545;\n}\n\n.reset-video-button:hover {\n  background-color: #c82333;\n}\n\n.video-player-wrapper-editor {\n  width: 100%;\n  position: relative;\n  padding-top: 56.25%; /* 16:9 Aspect Ratio */\n  background-color: #000;\n  border-radius: 8px;\n  overflow: hidden;\n  margin-bottom: 10px;\n}\n\n.main-video-player {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n}\n\n.player-controls-editor {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 15px;\n  margin-top: 20px;\n  width: 100%;\n}\n\n.player-controls-editor p {\n  margin: 0;\n  font-size: 1.1em;\n  color: #343a40;\n}\n\n.add-frame-button,\n.add-clip-button,\n.ai-analyze-button,\n.add-intro-outro-button {\n  background-color: #28a745;\n}\n\n.remove-vo-button {\n  background-color: #dc3545;\n  color: white;\n  border: none;\n  padding: 10px 20px;\n  border-radius: 5px;\n  cursor: pointer;\n  font-size: 14px;\n  transition: background-color 0.2s ease;\n}\n\n.remove-vo-button:hover {\n  background-color: #c82333;\n}\n\n.add-frame-button:hover,\n.add-clip-button:hover,\n.ai-analyze-button:hover:not(:disabled),\n.add-intro-outro-button:hover:not(:disabled) {\n  background-color: #218838;\n}\n\n.timeline-controls {\n  margin-bottom: 1rem;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  padding: 0;\n  position: relative;\n  height: 50px;\n  min-height: 50px;\n}\n\n.timeline-controls-left {\n  display: flex;\n  gap: 0.5rem;\n  align-items: center;\n  position: absolute;\n  left: 0;\n  top: 50%;\n  transform: translateY(-50%);\n}\n\n.timeline-controls-right {\n  display: flex;\n  gap: 0.5rem;\n  align-items: center;\n  position: absolute;\n  right: 0;\n  top: 50%;\n  transform: translateY(-50%);\n  max-width: calc(100% - 200px);\n}\n\n.ai-analyze-button:disabled {\n  background-color: #6c757d;\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n\n.ai-analyze-button.generating {\n  background-color: #ffc107;\n  color: #212529;\n}\n\n.ai-analyze-button.generating:disabled {\n  background-color: #ffc107;\n  color: #212529;\n  opacity: 0.8;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n.ai-analyze-button.disabled {\n  background-color: #6c757d;\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n\n.timeline-section-editor {\n  background-color: #ffffff;\n  padding: 25px;\n  border-radius: 10px;\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);\n  width: 100%;\n}\n\n.timeline-section-editor h2 {\n  color: #2c3e50;\n  margin-bottom: 20px;\n  font-size: 2em;\n  font-weight: 600;\n  text-align: center;\n}\n\n.empty-timeline-message {\n  color: #6c757d;\n  font-size: 1.1em;\n  text-align: center;\n  padding: 20px;\n  background-color: #e9ecef;\n  border-radius: 8px;\n}\n\n/* Timeline Component Styles */\n.timeline-container {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n/* TimelineItem Component Styles */\n.timeline-item {\n  display: flex;\n  flex-direction: column;\n  background-color: #fdfdfd;\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n  padding: 15px;\n  margin-bottom: 10px;\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);\n  transition: all 0.2s ease-in-out;\n}\n\n.timeline-item:hover {\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);\n  transform: translateY(-2px);\n}\n\n.timeline-item-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 10px;\n}\n\n.timeline-item-controls {\n  display: flex;\n  gap: 5px;\n}\n\n.timeline-item-header strong {\n  font-size: 1.1em;\n  color: #333;\n}\n\n.remove-item-button {\n  background-color: #dc3545;\n  color: white;\n  border: none;\n  border-radius: 50%;\n  width: 30px;\n  height: 30px;\n  padding: 0;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.remove-item-button:hover {\n  background-color: #c82333;\n}\n\n.remove-item-button svg {\n  width: 16px;\n  height: 16px;\n  fill: white;\n}\n\n.remove-item-button:hover {\n  background-color: #c82333;\n}\n\n.timeline-item-content {\n  display: flex;\n  flex-direction: row; /* Align items horizontally */\n  gap: 15px; /* Space between thumbnail and textarea */\n  align-items: flex-start; /* Align items to the top */\n}\n\n.timeline-media-container {\n  width: 160px; /* Increased width for better visibility */\n  height: 90px; \n  flex-shrink: 0; /* Prevent the thumbnail from shrinking */\n  overflow: hidden;\n  border-radius: 4px;\n  border: 1px solid #ddd;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: #f0f0f0;\n  position: relative; \n}\n\n.timeline-media {\n  width: 100%;\n  height: 100%;\n  object-fit: cover; \n}\n\n.timeline-item-textarea {\n  flex-grow: 1; /* Allow the textarea to take up remaining space */\n  padding: 8px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  font-size: 0.9em;\n  resize: vertical;\n  min-height: 90px; /* Match the height of the thumbnail container */\n}\n\n.scene-description,\n.scene-narration {\n  margin-top: 10px;\n  padding: 8px;\n  border: 1px solid #e0e0e0;\n  border-radius: 4px;\n  background-color: #f9f9f9;\n  font-size: 0.85em;\n  text-align: left;\n}\n\n.scene-description strong,\n.scene-narration strong {\n  color: #555;\n  margin-right: 5px;\n}\n\n.show-more-button {\n  background-color: #6c757d;\n  color: white;\n  padding: 5px 10px;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  font-size: 0.8em;\n  margin-top: 10px;\n  align-self: flex-start;\n}\n\n.show-more-button:hover {\n  background-color: #5a6268;\n}\n\n.timeline-item-accordion-content {\n  margin-top: 10px;\n  padding-top: 10px;\n  border-top: 1px solid #eee;\n  text-align: left;\n}\n\n.scene-description-edit,\n.scene-narration-edit {\n  margin-bottom: 10px;\n}\n\n.scene-description-edit label,\n.scene-narration-edit label {\n  display: block;\n  font-weight: bold;\n  margin-bottom: 5px;\n  color: #333;\n}\n\n.scene-description-edit textarea,\n.scene-narration-edit textarea {\n  width: 100%;\n  padding: 8px;\n  border: 1px solid #ced4da;\n  border-radius: 5px;\n  font-size: 0.9em;\n  resize: vertical;\n  min-height: 60px;\n}\n\n.scene-audio-section {\n  margin-bottom: 10px;\n}\n\n.scene-audio-section label {\n  display: block;\n  font-weight: bold;\n  margin-bottom: 5px;\n  color: #333;\n}\n\n.audio-controls-container {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.audio-player {\n  flex: 1;\n  margin-right: 10px;\n}\n\n.audio-player audio {\n  width: 100%;\n  max-width: 300px;\n}\n\n.audio-player p {\n  margin: 0;\n  color: #666;\n  font-style: italic;\n}\n\n.regenerate-audio-button,\n.regenerate-script-button {\n  background-color: #007bff;\n  color: white;\n  border: none;\n  padding: 8px 12px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 0.9em;\n  white-space: nowrap;\n  transition: background-color 0.2s ease;\n}\n\n.regenerate-audio-button:hover,\n.regenerate-script-button:hover {\n  background-color: #0056b3;\n}\n\n/* Voice Generation Dropdown Styles */\n.voice-generation-dropdown {\n  position: relative;\n  display: inline-block;\n}\n\n.dropdown-toggle {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.voice-dropdown-menu {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  right: 0;\n  background-color: white;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  z-index: 1000;\n  margin-top: 2px;\n  min-width: 250px;\n}\n\n.voice-variation-option {\n  width: 100%;\n  padding: 12px 16px;\n  border: none;\n  background-color: transparent;\n  text-align: left;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n  border-bottom: 1px solid #eee;\n}\n\n.voice-variation-option:last-child {\n  border-bottom: none;\n}\n\n.voice-variation-option:hover {\n  background-color: #f8f9fa;\n}\n\n.variation-label {\n  font-weight: bold;\n  color: #333;\n  margin-bottom: 4px;\n}\n\n.variation-description {\n  font-size: 0.85em;\n  color: #666;\n  font-style: italic;\n}\n\n.regenerate-script-button {\n  background-color: #28a745;\n}\n\n.regenerate-script-button:hover {\n  background-color: #218838;\n}\n\n\n.frame-preview-button {\n  position: absolute;\n  bottom: 5px;\n  right: 85px; /* Position before Edit Clip button */\n  background-color: rgba(128, 0, 128, 0.8); /* Purple with transparency */\n  color: white;\n  border: none;\n  border-radius: 4px;\n  padding: 5px 8px;\n  font-size: 0.8em;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n}\n\n.frame-preview-button:hover {\n  background-color: #800080; /* Darker purple on hover */\n}\n\n.edit-clip-button {\n  position: absolute;\n  bottom: 5px;\n  right: 5px;\n  background-color: rgba(0, 123, 255, 0.8); /* Blue with transparency */\n  color: white;\n  border: none;\n  border-radius: 4px;\n  padding: 5px 8px;\n  font-size: 0.8em;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n}\n\n.edit-clip-button:hover {\n  background-color: #007bff;\n}\n\n.clip-editor-button {\n  background-color: #6c757d;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  padding: 5px 8px;\n  font-size: 0.8em;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n  margin-right: 5px;\n}\n\n.clip-editor-button:hover {\n  background-color: #5a6268;\n}\n\n/* Clip editor button color status indicators */\n.clip-editor-button.clip-status-red {\n  background-color: #dc3545; /* Red for clips edited in original version */\n  border: 2px solid #dc3545;\n}\n\n.clip-editor-button.clip-status-red:hover {\n  background-color: #c82333;\n  border-color: #c82333;\n}\n\n.clip-editor-button.clip-status-green {\n  background-color: #28a745; /* Green for clips edited in current language variant */\n  border: 2px solid #28a745;\n}\n\n.clip-editor-button.clip-status-green:hover {\n  background-color: #218838;\n  border-color: #218838;\n}\n\n.clip-editor-button.clip-status-grey {\n  background-color: #6c757d; /* Grey for no edits available */\n  border: 2px solid #6c757d;\n}\n\n.clip-editor-button.clip-status-grey:hover {\n  background-color: #5a6268;\n  border-color: #5a6268;\n}\n\n/* Modal Styles (ConfirmationDialog and ClipEditModal) */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.6);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.modal-content {\n  background-color: #ffffff;\n  padding: 20px; /* Reduced padding */\n  border-radius: 10px;\n  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);\n  text-align: center;\n  max-width: 500px;\n  width: 90%;\n  animation: fadeIn 0.3s ease-out;\n}\n\n.modal-title {\n  color: #2c3e50;\n  font-size: 1.8em;\n  margin: 0; /* Remove all margins */\n}\n\n.modal-message {\n  color: #6c757d;\n  font-size: 1.1em;\n  margin-bottom: 25px;\n  line-height: 1.5;\n}\n\n.modal-actions {\n  display: flex;\n  justify-content: center;\n  gap: 15px;\n}\n\n.modal-confirm-button,\n.modal-cancel-button {\n  padding: 10px 20px;\n  border: none;\n  border-radius: 5px;\n  font-size: 1em;\n  cursor: pointer;\n  transition: background-color 0.3s ease, transform 0.2s ease;\n}\n\n.modal-confirm-button {\n  background-color: #dc3545; /* Red for delete */\n  color: white;\n}\n\n.modal-confirm-button:hover {\n  background-color: #c82333;\n}\n\n.modal-cancel-button {\n  background-color: #6c757d; /* Grey for cancel */\n  color: white;\n}\n\n.modal-cancel-button:hover {\n  background-color: #5a6268;\n}\n\n/* Frame Preview Modal Specific Styles */\n.frame-preview-modal {\n  max-width: 800px !important;\n  width: 90% !important;\n}\n\n.frame-info-section {\n  background-color: #f8f9fa;\n  padding: 15px;\n  border-radius: 8px;\n  margin-bottom: 20px;\n  text-align: left;\n}\n\n.frame-info-section p {\n  margin: 5px 0;\n  color: #495057;\n  font-size: 0.95em;\n}\n\n.frame-info-section strong {\n  color: #2c3e50;\n  font-weight: 600;\n}\n\n.frame-image-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: #f8f9fa;\n  border-radius: 8px;\n  padding: 20px;\n  margin-bottom: 20px;\n  min-height: 300px;\n}\n\n.frame-preview-image {\n  max-width: 100%;\n  max-height: 500px;\n  border-radius: 8px;\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.15);\n  object-fit: contain;\n}\n\n.no-annotation-message {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  color: #6c757d;\n  font-style: italic;\n}\n\n.no-annotation-message p {\n  margin: 0;\n  font-size: 1.1em;\n}\n\n@keyframes fadeIn {\n  from { opacity: 0; transform: scale(0.9); }\n  to { opacity: 1; transform: scale(1); }\n}\n\n/* Loading Overlay Styles */\n.loading-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.7);\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  z-index: 2000; /* Higher than other modals */\n  color: white;\n  font-size: 1.2em;\n}\n\n.loading-spinner {\n  border: 4px solid rgba(255, 255, 255, 0.3);\n  border-radius: 50%;\n  border-top: 4px solid #007bff;\n  width: 40px;\n  height: 40px;\n  -webkit-animation: spin 1s linear infinite; /* Safari */\n  animation: spin 1s linear infinite;\n  margin-bottom: 15px;\n}\n\n/* Safari */\n@-webkit-keyframes spin {\n  0% { -webkit-transform: rotate(0deg); }\n  100% { -webkit-transform: rotate(360deg); }\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); } \n  100% { transform: rotate(360deg); }\n}\n\n/* Message Popup Styles */\n.message-popup {\n  position: fixed;\n  top: 20px;\n  left: 50%;\n  transform: translateX(-50%);\n  padding: 15px 25px;\n  border-radius: 8px;\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);\n  color: white;\n  font-size: 1.1em;\n  z-index: 2001; /* Even higher */\n  display: flex;\n  align-items: center;\n  gap: 15px;\n  animation: slideIn 0.5s ease-out;\n}\n\n.message-popup.success {\n  background-color: #28a745; /* Green */\n}\n\n.message-popup.error {\n  background-color: #dc3545; /* Red */\n}\n\n.message-popup p {\n  margin: 0;\n}\n\n.message-popup button {\n  background: none;\n  border: 1px solid white;\n  color: white;\n  padding: 5px 10px;\n  border-radius: 5px;\n  cursor: pointer;\n  font-size: 0.9em;\n  transition: background-color 0.2s ease;\n}\n\n.message-popup button:hover {\n  background-color: rgba(255, 255, 255, 0.2);\n}\n\n@keyframes slideIn {\n  from { top: -50px; opacity: 0; }\n  to { top: 20px; opacity: 1; }\n}\n\n/* ClipEditModal Specific Styles - Large Size */\n.clip-edit-modal-large {\n  background-color: #ffffff;\n  padding: 15px 25px 25px 25px; /* Reduced top padding */\n  border-radius: 12px;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);\n  text-align: center;\n  width: 80vw; /* 80% of screen width for optimal preview */\n  max-width: 80vw; /* Ensure it doesn't exceed 80% */\n  max-height: 95vh; /* 95% of viewport height for more space */\n  overflow-y: auto; /* Add scroll if content overflows */\n  position: relative; /* For proper positioning */\n}\n\n/* All child elements for large modal */\n.clip-edit-modal-large .controls input[type=\"range\"] {\n  flex-grow: 1;\n  -webkit-appearance: none;\n  appearance: none;\n  height: 8px;\n  background: #ddd;\n  border-radius: 5px;\n  outline: none;\n  opacity: 0.7;\n  transition: opacity .2s;\n}\n\n.clip-edit-modal-large .controls input[type=\"range\"]::-webkit-slider-thumb {\n  -webkit-appearance: none;\n  appearance: none;\n  width: 18px;\n  height: 18px;\n  border-radius: 50%;\n  background: #007bff;\n  cursor: pointer;\n}\n\n.clip-edit-modal-large .controls input[type=\"range\"]::-moz-range-thumb {\n  width: 18px;\n  height: 18px;\n  border-radius: 50%;\n  background: #007bff;\n  cursor: pointer;\n}\n\n.clip-edit-modal-large .time-inputs {\n  display: flex;\n  justify-content: center;\n  gap: 30px;\n  margin-top: 10px;\n  margin-bottom: 20px;\n  padding: 20px;\n  background: #ffffff;\n  border: 1px solid #e9ecef;\n  border-radius: 8px;\n}\n\n.clip-edit-modal-large .time-inputs label {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  font-size: 1em;\n}\n\n.clip-edit-modal-large .time-inputs input[type=\"number\"] {\n  width: 80px;\n  padding: 8px;\n  border: 1px solid #ced4da;\n  border-radius: 5px;\n  font-size: 0.9em;\n}\n\n/* Compact Controls for ClipEditModal */\n.clip-edit-modal-large .compact-controls {\n  display: flex;\n  align-items: center;\n  gap: 15px;\n  padding: 15px 20px;\n  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);\n  border-radius: 10px;\n  margin: 15px 0;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  flex-wrap: wrap;\n}\n\n.clip-edit-modal-large .control-btn {\n  padding: 8px 16px;\n  border: none;\n  border-radius: 6px;\n  font-size: 0.9rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  background: #007bff;\n  color: white;\n  box-shadow: 0 2px 4px rgba(0, 123, 255, 0.3);\n}\n\n.clip-edit-modal-large .control-btn:hover {\n  background: #0056b3;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 8px rgba(0, 123, 255, 0.4);\n}\n\n.clip-edit-modal-large .capture-btn {\n  background: #28a745;\n  box-shadow: 0 2px 4px rgba(40, 167, 69, 0.3);\n}\n\n.clip-edit-modal-large .capture-btn:hover {\n  background: #218838;\n  box-shadow: 0 4px 8px rgba(40, 167, 69, 0.4);\n}\n\n.clip-edit-modal-large .capture-btn:disabled {\n  background: #6c757d;\n  cursor: not-allowed;\n  transform: none;\n  box-shadow: none;\n}\n\n.clip-edit-modal-large .time-display {\n  font-size: 0.9rem;\n  font-weight: 600;\n  color: #495057;\n  background: white;\n  padding: 6px 12px;\n  border-radius: 4px;\n  border: 1px solid #dee2e6;\n  min-width: 120px;\n  text-align: center;\n}\n\n.clip-edit-modal-large .seek-slider {\n  flex: 1;\n  min-width: 200px;\n  height: 6px;\n  background: linear-gradient(to right, #007bff 0%, #dee2e6 0%);\n  border-radius: 3px;\n  outline: none;\n  -webkit-appearance: none;\n  appearance: none;\n}\n\n.clip-edit-modal-large .seek-slider::-webkit-slider-thumb {\n  -webkit-appearance: none;\n  appearance: none;\n  width: 18px;\n  height: 18px;\n  border-radius: 50%;\n  background: #007bff;\n  cursor: pointer;\n  box-shadow: 0 2px 4px rgba(0, 123, 255, 0.3);\n  transition: all 0.2s ease;\n}\n\n.clip-edit-modal-large .seek-slider::-webkit-slider-thumb:hover {\n  background: #0056b3;\n  transform: scale(1.1);\n  box-shadow: 0 3px 6px rgba(0, 123, 255, 0.4);\n}\n\n.clip-edit-modal-large .time-inputs-inline {\n  display: flex;\n  gap: 15px;\n  align-items: center;\n}\n\n.clip-edit-modal-large .time-label {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 0.85rem;\n  font-weight: 500;\n  color: #495057;\n}\n\n.clip-edit-modal-large .time-input {\n  width: 70px;\n  padding: 6px 8px;\n  border: 1px solid #ced4da;\n  border-radius: 4px;\n  font-size: 0.85rem;\n  text-align: center;\n  transition: border-color 0.2s ease;\n}\n\n.clip-edit-modal-large .time-input:focus {\n  outline: none;\n  border-color: #007bff;\n  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);\n}\n\n/* Legacy ClipEditModal class - keep for compatibility */\n.clip-edit-modal {\n  max-width: 90vw;\n  width: 1200px;\n  max-height: 90vh;\n  overflow-y: auto;\n}\n\n.clip-edit-modal-large .player-wrapper,\n.clip-edit-modal .player-wrapper {\n  position: relative;\n  height: 600px; /* Set a fixed height for better video preview */\n  margin-bottom: 20px; /* Add some margin for spacing */\n  border-radius: 8px;\n  overflow: hidden;\n  background: #000; /* Black background for video */\n}\n\n.clip-edit-modal-large .react-player,\n.clip-edit-modal .react-player {\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n\n.clip-edit-modal-large .controls,\n.clip-edit-modal .controls {\n  display: flex;\n  align-items: center;\n  gap: 15px;\n  margin-top: 10px; /* Add some margin */\n  margin-bottom: 20px; /* Add bottom margin */\n  padding: 15px; /* Add padding for better spacing */\n  background: #f8f9fa; /* Light background for controls */\n  border-radius: 8px;\n}\n\n.clip-edit-modal-large .controls button,\n.clip-edit-modal .controls button {\n  padding: 8px 15px;\n  font-size: 0.9em;\n}\n\n.clip-edit-modal-large .controls span,\n.clip-edit-modal .controls span {\n  font-size: 1em;\n  color: #555;\n}\n\n.clip-edit-modal .controls input[type=\"range\"] {\n  flex-grow: 1;\n  -webkit-appearance: none;\n  appearance: none;\n  height: 8px;\n  background: #ddd;\n  border-radius: 5px;\n  outline: none;\n  opacity: 0.7;\n  transition: opacity .2s;\n}\n\n.clip-edit-modal .controls input[type=\"range\"]::-webkit-slider-thumb {\n  -webkit-appearance: none;\n  appearance: none;\n  width: 18px;\n  height: 18px;\n  border-radius: 50%;\n  background: #007bff;\n  cursor: pointer;\n}\n\n.clip-edit-modal .controls input[type=\"range\"]::-moz-range-thumb {\n  width: 18px;\n  height: 18px;\n  border-radius: 50%;\n  background: #007bff;\n  cursor: pointer;\n}\n\n.clip-edit-modal .time-inputs {\n  display: flex;\n  justify-content: center;\n  gap: 30px;\n  margin-top: 10px; /* Add margin */\n  margin-bottom: 20px; /* Add bottom margin */\n  padding: 20px; /* Add padding */\n  background: #ffffff;\n  border: 1px solid #e9ecef;\n  border-radius: 8px;\n}\n\n.clip-edit-modal .time-inputs label {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  font-size: 1em;\n}\n\n.clip-edit-modal .time-inputs input[type=\"number\"] {\n  width: 80px;\n  padding: 8px;\n  border: 1px solid #ced4da;\n  border-radius: 5px;\n  font-size: 0.9em;\n}\n\n.advanced-edit-button {\n  background-color: #007bff;\n  color: white;\n  padding: 8px 12px;\n  border-radius: 5px;\n  font-size: 0.9em;\n  margin-right: 5px;\n}\n\n.advanced-edit-button:hover {\n  background-color: #0056b3;\n}\n\n/* VideoCanvasPage Styles */\n.video-canvas-page-container {\n    font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif;\n    background-color: #282c34;\n    color: #ffffff;\n    margin: 0;\n    padding: 20px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    min-height: 100vh;\n}\n\n.video-canvas-header {\n    background-color: #2c3e50;\n    min-height: 70px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 0 20px;\n    color: white;\n    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\n    width: 100%;\n    margin-bottom: 20px;\n}\n\n.video-canvas-header h1 {\n    color: #61dafb;\n    margin: 0;\n}\n\n.video-editor-main-content {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 15px;\n    margin-bottom: 20px;\n    width: 100%;\n}\n\n.editor-container {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 15px;\n    margin-bottom: 20px;\n}\n\n#previewCanvas {\n    border: 2px solid #61dafb;\n    background-color: #000;\n    max-width: 90vw; /* Responsive canvas */\n}\n\n#sourceVideo {\n    /* We hide the source video; it's just for data and playback control */\n    display: none;\n}\n\n.controls {\n    display: flex;\n    gap: 10px;\n    align-items: center;\n}\n\n.controls button, .controls input[type=\"file\"] {\n    padding: 8px 12px;\n    border-radius: 5px;\n    border: 1px solid #61dafb;\n    background-color: #3e4451;\n    color: #ffffff;\n    cursor: pointer;\n    font-size: 14px;\n}\n\n.controls button:hover {\n    background-color: #4f5766;\n}\n\n.controls button:disabled {\n    background-color: #20232a;\n    color: #777;\n    cursor: not-allowed;\n}\n\n#timeline-container {\n    width: 90vw;\n    max-width: 800px;\n    height: auto;\n    background-color: #20232a;\n    border-radius: 5px;\n    padding: 10px;\n    position: relative;\n    overflow-x: auto;\n    border: 1px solid #4f5766;\n}\n\n.track {\n    position: relative;\n    height: 40px;\n    background-color: #3e4451;\n    border-radius: 4px;\n    margin-bottom: 8px;\n    box-sizing: border-box;\n}\n\n.timeline-clip {\n    position: absolute;\n    top: 5px;\n    height: 30px;\n    background-color: #61dafb;\n    border-radius: 4px;\n    box-sizing: border-box;\n    border: 1px solid #1a9fcc;\n    cursor: move;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: #000;\n    font-size: 12px;\n    font-weight: bold;\n    overflow: hidden;\n    white-space: nowrap;\n}\n\n.timeline-clip.video-clip {\n    background-color: #fca311;\n    border-color: #c9820e;\n}\n\n/* Resize Handles */\n.timeline-clip::before,\n.timeline-clip::after {\n    content: '';\n    position: absolute;\n    top: 0;\n    width: 8px;\n    height: 100%;\n    background-color: rgba(0, 0, 0, 0.5);\n    cursor: ew-resize; /* East-West resize cursor */\n}\n.timeline-clip::before {\n    left: 0;\n}\n.timeline-clip::after {\n    right: 0;\n}\n\n#downloadLinkContainer {\n    margin-top: 20px;\n}\n\n/* YouTube Details Modal Styles */\n.youtube-details-modal {\n  max-width: 800px;\n  width: 90%;\n  max-height: 80vh;\n  overflow-y: auto;\n}\n\n.youtube-details-content {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.youtube-detail-section {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.detail-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 8px;\n}\n\n.detail-header h3 {\n  margin: 0;\n  color: #333;\n  font-size: 1.2em;\n}\n\n.copy-button {\n  background-color: #007bff;\n  color: white;\n  border: none;\n  padding: 6px 12px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 0.9em;\n  transition: background-color 0.2s ease;\n}\n\n.copy-button:hover {\n  background-color: #0056b3;\n}\n\n.youtube-title-textarea {\n  width: 100%;\n  padding: 10px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-family: Arial, sans-serif;\n  font-size: 1em;\n  resize: vertical;\n  background-color: #f9f9f9;\n}\n\n.youtube-description-textarea {\n  width: 100%;\n  padding: 10px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-family: Arial, sans-serif;\n  font-size: 0.9em;\n  resize: vertical;\n  background-color: #f9f9f9;\n  line-height: 1.4;\n}\n\n.additional-prompt-textarea {\n  width: 100%;\n  padding: 10px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-family: Arial, sans-serif;\n  font-size: 0.9em;\n  resize: vertical;\n  background-color: #ffffff;\n  line-height: 1.4;\n  border-color: #007bff;\n  box-shadow: 0 0 0 1px rgba(0, 123, 255, 0.1);\n}\n\n.additional-prompt-textarea:focus {\n  outline: none;\n  border-color: #007bff;\n  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);\n}\n\n.additional-prompt-section {\n  margin-bottom: 20px;\n  padding: 15px;\n  background-color: #f8f9fa;\n  border-radius: 6px;\n  border-left: 4px solid #007bff;\n}\n\n.modal-actions {\n  display: flex;\n  gap: 10px;\n  justify-content: flex-end;\n  margin-top: 20px;\n  padding-top: 20px;\n  border-top: 1px solid #eee;\n}\n\n.regenerate-button {\n  background-color: #28a745;\n  color: white;\n  border: none;\n  padding: 10px 20px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 1em;\n  transition: background-color 0.2s ease;\n}\n\n.regenerate-button:hover {\n  background-color: #218838;\n}\n\n.close-button {\n  background-color: #6c757d;\n  color: white;\n  border: none;\n  padding: 10px 20px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 1em;\n  transition: background-color 0.2s ease;\n}\n\n.close-button:hover {\n  background-color: #5a6268;\n}\n\n.loading-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 15px;\n  padding: 40px;\n}\n\n.error-message {\n  text-align: center;\n  color: #dc3545;\n  padding: 20px;\n}\n\n.retry-button {\n  background-color: #dc3545;\n  color: white;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 4px;\n  cursor: pointer;\n  margin-top: 10px;\n  transition: background-color 0.2s ease;\n}\n\n.retry-button:hover {\n  background-color: #c82333;\n}\n\n/* Capture Frame Button */\n.capture-frame-button {\n  background-color: #17a2b8;\n  color: white;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 0.9em;\n  transition: background-color 0.2s ease;\n  margin-left: 10px;\n}\n\n.capture-frame-button:hover:not(:disabled) {\n  background-color: #138496;\n}\n\n.capture-frame-button:disabled {\n  background-color: #6c757d;\n  cursor: not-allowed;\n}\n\n/* Edit Frame Button */\n.edit-frame-button {\n  background-color: #28a745;\n  color: white;\n  border: none;\n  border-radius: 50%;\n  width: 30px;\n  height: 30px;\n  padding: 0;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-right: 5px;\n}\n\n.edit-frame-button:hover {\n  background-color: #218838;\n}\n\n.edit-frame-button svg {\n  width: 16px;\n  height: 16px;\n  fill: white;\n}\n\n/* Frame Editor Modal Styles */\n.frame-editor-modal {\n  max-width: 95vw;\n  width: 1200px;\n  max-height: 95vh;\n  overflow-y: auto;\n}\n\n.frame-editor-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n  padding-bottom: 10px;\n  border-bottom: 1px solid #eee;\n}\n\n.frame-editor-header h2 {\n  margin: 0;\n  color: #333;\n  font-size: 1.4em;\n}\n\n.modal-close-button {\n  background: none;\n  border: none;\n  font-size: 24px;\n  cursor: pointer;\n  color: #666;\n  padding: 0;\n  width: 30px;\n  height: 30px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.modal-close-button:hover {\n  color: #333;\n  background-color: #f0f0f0;\n  border-radius: 50%;\n}\n\n.frame-editor-toolbar {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n  padding: 15px;\n  background-color: #f8f9fa;\n  border-radius: 8px;\n  margin-bottom: 20px;\n  flex-wrap: wrap;\n}\n\n.tool-group {\n  display: flex;\n  gap: 8px;\n}\n\n.tool-button {\n  background-color: #fff;\n  border: 1px solid #ddd;\n  padding: 8px 16px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 0.9em;\n  transition: all 0.2s ease;\n}\n\n.tool-button:hover {\n  background-color: #e9ecef;\n  border-color: #adb5bd;\n}\n\n.tool-button.active {\n  background-color: #007bff;\n  color: white;\n  border-color: #007bff;\n}\n\n.color-group {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.color-picker {\n  width: 40px;\n  height: 40px;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.text-group {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.text-input {\n  padding: 8px 12px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-size: 0.9em;\n  width: 150px;\n}\n\n.action-group {\n  display: flex;\n  gap: 8px;\n}\n\n.action-button {\n  background-color: #6c757d;\n  color: white;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 0.9em;\n  transition: background-color 0.2s ease;\n}\n\n.action-button:hover:not(:disabled) {\n  background-color: #5a6268;\n}\n\n.action-button:disabled {\n  background-color: #e9ecef;\n  color: #6c757d;\n  cursor: not-allowed;\n}\n\n.action-button.delete {\n  background-color: #dc3545;\n}\n\n.action-button.delete:hover:not(:disabled) {\n  background-color: #c82333;\n}\n\n.canvas-container {\n  display: flex;\n  justify-content: center;\n  margin-bottom: 20px;\n  padding: 20px;\n  background-color: #f0f0f0;\n  border-radius: 8px;\n  overflow: auto;\n}\n\n.frame-editor-actions {\n  display: flex;\n  justify-content: space-between;\n  gap: 10px;\n  padding-top: 20px;\n  border-top: 1px solid #eee;\n}\n\n.export-button {\n  background-color: #28a745;\n  color: white;\n  border: none;\n  padding: 12px 24px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 1em;\n  transition: background-color 0.2s ease;\n}\n\n.export-button:hover {\n  background-color: #218838;\n}\n\n.reset-button {\n  background-color: #ffc107;\n  color: #212529;\n  border: none;\n  padding: 12px 24px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-weight: 500;\n  transition: background-color 0.2s ease;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.reset-button:hover {\n  background-color: #e0a800;\n}\n\n/* Reset Confirmation Modal Styles */\n.modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n  padding-bottom: 10px;\n  border-bottom: 1px solid #eee;\n}\n\n.modal-header h3 {\n  margin: 0;\n  color: #333;\n  font-size: 1.2em;\n}\n\n.modal-close {\n  background: none;\n  border: none;\n  cursor: pointer;\n  color: #666;\n  padding: 5px;\n  border-radius: 3px;\n  transition: background-color 0.2s;\n}\n\n.modal-close:hover {\n  background-color: #f5f5f5;\n}\n\n.modal-body {\n  margin-bottom: 20px;\n  text-align: left;\n}\n\n.modal-body p {\n  margin: 0 0 10px 0;\n  color: #333;\n  line-height: 1.4;\n}\n\n.modal-footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n}\n\n.modal-button {\n  padding: 10px 20px;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-weight: 500;\n  transition: background-color 0.2s;\n}\n\n.modal-button.cancel {\n  background-color: #6c757d;\n  color: white;\n}\n\n.modal-button.cancel:hover {\n  background-color: #5a6268;\n}\n\n.modal-button.confirm {\n  background-color: #dc3545;\n  color: white;\n}\n\n.modal-button.confirm:hover {\n  background-color: #c82333;\n}\n\n/* Inline Duration Controls (in playback toolbar) */\n.time-display-container {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n}\n\n.duration-control-inline {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 12px;\n  background: #1a1a1a;\n  border: 1px solid #444;\n  border-radius: 6px;\n}\n\n.duration-input-inline {\n  width: 60px;\n  background: transparent;\n  border: none;\n  color: #fff;\n  font-size: 0.85em;\n  text-align: center;\n  padding: 2px 4px;\n}\n\n.duration-input-inline:focus {\n  outline: none;\n  background: #2a2a2a;\n  border-radius: 3px;\n}\n\n.duration-unit-inline {\n  color: #aaa;\n  font-size: 0.8em;\n  font-weight: 500;\n}\n\n.duration-reset-inline {\n  background: none;\n  border: none;\n  color: #aaa;\n  cursor: pointer;\n  padding: 2px;\n  border-radius: 3px;\n  transition: all 0.2s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.duration-reset-inline:hover {\n  color: #fff;\n  background: #444;\n}\n\n/* Videos Project Button */\n.videos-project-button {\n  background-color: #17a2b8;\n  color: white;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 0.9em;\n  font-weight: 500;\n  transition: background-color 0.2s ease;\n}\n\n.videos-project-button:hover {\n  background-color: #138496;\n}\n\n/* Project Videos Page Styles */\n.project-videos-page {\n  min-height: 100vh;\n  background-color: #1a1a1a;\n  color: #fff;\n}\n\n.project-videos-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 2rem;\n  background: #2a2a2a;\n  border-bottom: 1px solid #444;\n}\n\n.header-content h1 {\n  margin: 0 0 0.5rem 0;\n  color: #fff;\n  font-size: 1.8rem;\n}\n\n.project-description {\n  margin: 0;\n  color: #aaa;\n  font-size: 0.9rem;\n}\n\n.header-actions {\n  display: flex;\n  gap: 1rem;\n}\n\n.back-button, .edit-button, .sync-media-button {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.75rem 1.5rem;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  font-weight: 500;\n  transition: background-color 0.2s;\n  text-decoration: none;\n}\n\n.back-button {\n  background-color: #f8f9fa;\n  border: 1px solid #dee2e6;\n  color: #495057;\n}\n\n.back-button:hover {\n  background-color: #e9ecef;\n  border-color: #adb5bd;\n  color: #343a40;\n  transform: translateY(-1px);\n}\n\n.edit-button {\n  background-color: #007bff;\n  color: white;\n}\n\n.edit-button:hover {\n  background-color: #0056b3;\n}\n\n.sync-media-button {\n  background-color: #28a745;\n  color: white;\n}\n\n.sync-media-button:hover:not(:disabled) {\n  background-color: #218838;\n}\n\n.sync-media-button:disabled {\n  background-color: #6c757d;\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n\n.sync-media-button.syncing {\n  background-color: #fd7e14;\n}\n\n.sync-media-button.syncing svg {\n  animation: rotate 1s linear infinite;\n}\n\n@keyframes rotate {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.project-videos-main {\n  padding: 2rem;\n}\n\n.loading-container, .error-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 50vh;\n  text-align: center;\n}\n\n.loading-spinner {\n  width: 40px;\n  height: 40px;\n  border: 4px solid #444;\n  border-top: 4px solid #007bff;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n  margin-bottom: 1rem;\n}\n\n.no-videos-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 50vh;\n  text-align: center;\n}\n\n.no-videos-icon {\n  color: #666;\n  margin-bottom: 1rem;\n}\n\n.no-videos-container h2 {\n  color: #fff;\n  margin-bottom: 0.5rem;\n}\n\n.no-videos-container p {\n  color: #aaa;\n  margin-bottom: 2rem;\n}\n\n.create-video-button {\n  background-color: #28a745;\n  color: white;\n  border: none;\n  padding: 1rem 2rem;\n  border-radius: 6px;\n  cursor: pointer;\n  font-weight: 500;\n  transition: background-color 0.2s;\n}\n\n.create-video-button:hover {\n  background-color: #218838;\n}\n\n.videos-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(400px, 1fr));\n  gap: 1.5rem;\n}\n\n.video-card {\n  background: #2a2a2a;\n  border: 1px solid #444;\n  border-radius: 8px;\n  padding: 1.5rem;\n  transition: all 0.2s ease;\n}\n\n.video-card:hover {\n  border-color: #666;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);\n}\n\n.video-info {\n  display: flex;\n  align-items: flex-start;\n  gap: 1rem;\n  margin-bottom: 1rem;\n}\n\n.video-icon {\n  color: #007bff;\n  flex-shrink: 0;\n}\n\n.video-details {\n  flex: 1;\n  min-width: 0;\n}\n\n.video-name {\n  margin: 0 0 0.5rem 0;\n  color: #fff;\n  font-size: 1rem;\n  font-weight: 600;\n  word-break: break-all;\n}\n\n.video-metadata {\n  margin: 0;\n  color: #aaa;\n  font-size: 0.85rem;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.separator {\n  color: #666;\n}\n\n.video-actions {\n  display: flex;\n  gap: 0.75rem;\n}\n\n.download-button, .delete-button {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.5rem 1rem;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 0.85rem;\n  font-weight: 500;\n  transition: background-color 0.2s;\n}\n\n.download-button {\n  background-color: #28a745;\n  color: white;\n}\n\n.download-button:hover {\n  background-color: #218838;\n}\n\n.delete-button {\n  background-color: #dc3545;\n  color: white;\n}\n\n.delete-button:hover {\n  background-color: #c82333;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n/* Header buttons container */\n.header-buttons {\n  display: flex;\n  gap: 10px;\n  align-items: center;\n}\n\n/* Header Actions Container */\n.header-actions {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n/* DB Operations Dropdown */\n.db-dropdown {\n  position: relative;\n  display: inline-block;\n}\n\n.db-operations-button {\n  background-color: #f8f9fa;\n  border: 1px solid #dee2e6;\n  color: #495057;\n  padding: 10px 16px;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 0.9em;\n  font-weight: 500;\n  transition: all 0.2s ease;\n  white-space: nowrap;\n}\n\n.db-operations-button:hover {\n  background-color: #e9ecef;\n  border-color: #adb5bd;\n  color: #343a40;\n  transform: translateY(-1px);\n}\n\n\n.db-dropdown-content {\n  position: absolute;\n  right: 0;\n  top: 100%;\n  min-width: 180px;\n  background-color: white;\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  z-index: 1000;\n  overflow: hidden;\n  margin-top: 4px;\n}\n\n.db-dropdown-item {\n  display: block;\n  width: 100%;\n  padding: 12px 16px;\n  border: none;\n  background: none;\n  text-align: left;\n  cursor: pointer;\n  font-size: 14px;\n  color: #333;\n  transition: background-color 0.2s ease;\n  white-space: nowrap;\n}\n\n.db-dropdown-item:hover:not(:disabled) {\n  background-color: #f5f5f5;\n}\n\n.db-dropdown-item:disabled {\n  color: #999;\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n\n.db-dropdown-item + .db-dropdown-item {\n  border-top: 1px solid #f0f0f0;\n}\n\n/* Settings Button */\n.settings-button {\n  background-color: #f8f9fa;\n  border: 1px solid #dee2e6;\n  color: #495057;\n  font-size: 0.9em;\n  cursor: pointer;\n  padding: 10px 16px;\n  border-radius: 6px;\n  transition: all 0.2s ease;\n  font-weight: 500;\n  white-space: nowrap;\n}\n\n.settings-button:hover {\n  background-color: #e9ecef;\n  border-color: #adb5bd;\n  color: #343a40;\n  transform: translateY(-1px);\n}\n\n/* Logout Button */\n.logout-button {\n  background-color: #f8f9fa;\n  border: 1px solid #dee2e6;\n  color: #495057;\n  font-size: 0.9em;\n  cursor: pointer;\n  padding: 10px 16px;\n  border-radius: 6px;\n  transition: all 0.2s ease;\n  font-weight: 500;\n  white-space: nowrap;\n}\n\n.logout-button:hover {\n  background-color: #e9ecef;\n  border-color: #adb5bd;\n  color: #343a40;\n  transform: translateY(-1px);\n}\n\n/* YouTube Linking button styling */\n.youtube-linking-button {\n  background: linear-gradient(135deg, #FF0000 0%, #CC0000 100%);\n  color: white;\n  border: none;\n  padding: 10px 16px;\n  border-radius: 6px;\n  cursor: pointer;\n  font-weight: 600;\n  font-size: 14px;\n  transition: all 0.2s ease;\n  text-decoration: none;\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n}\n\n.youtube-linking-button:hover {\n  background: linear-gradient(135deg, #CC0000 0%, #990000 100%);\n  transform: translateY(-1px);\n  box-shadow: 0 4px 8px rgba(255, 0, 0, 0.3);\n}\n\n\n/* Master Project Styles */\n.create-master-project-button {\n  background-color: #28a745;\n  color: white;\n  border: none;\n  padding: 12px 24px;\n  border-radius: 6px;\n  font-size: 1rem;\n  cursor: pointer;\n  margin-bottom: 20px;\n  font-weight: 500;\n  transition: background-color 0.2s;\n}\n.create-master-project-button:hover {\n  background-color: #218838;\n}\n\n.master-project-actions {\n  width: 100%;\n  max-width: 1200px;\n  display: flex;\n  justify-content: flex-start;\n  margin-bottom: 10px;\n}\n\n.master-projects-section {\n  width: 100%;\n  max-width: 1200px;\n}\n\n/* Loading state for master projects */\n.loading-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 60px 20px;\n  text-align: center;\n  min-height: 200px;\n}\n\n.loading-container .loading-spinner {\n  width: 40px;\n  height: 40px;\n  border: 4px solid #f3f3f3;\n  border-top: 4px solid #007bff;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n  margin-bottom: 20px;\n}\n\n.loading-container p {\n  color: #6c757d;\n  font-size: 1rem;\n  margin: 0;\n}\n\n/* Master Project Controls (Search + Create Button) */\n.master-project-controls {\n  width: 100%;\n  max-width: 1200px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 20px;\n  margin-bottom: 20px;\n}\n\n.search-container {\n  flex: 1;\n  max-width: 400px;\n}\n\n.search-input {\n  width: 100%;\n  padding: 12px 16px;\n  border: 1px solid #ced4da;\n  border-radius: 6px;\n  font-size: 1rem;\n  transition: border-color 0.2s ease, box-shadow 0.2s ease;\n}\n\n.search-input:focus {\n  outline: none;\n  border-color: #007bff;\n  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);\n}\n\n.search-input::placeholder {\n  color: #6c757d;\n}\n\n/* Pagination Styles */\n.pagination-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 16px;\n  margin-top: 30px;\n  padding: 20px;\n  background: #f8f9fa;\n  border-radius: 8px;\n  border: 1px solid #e9ecef;\n}\n\n.pagination-info {\n  font-size: 0.9rem;\n  color: #6c757d;\n  font-weight: 500;\n}\n\n.pagination-controls {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.pagination-button {\n  background-color: #ffffff;\n  border: 1px solid #dee2e6;\n  color: #495057;\n  padding: 8px 12px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 0.9rem;\n  transition: all 0.2s ease;\n  min-width: 40px;\n  text-align: center;\n}\n\n.pagination-button:hover:not(:disabled) {\n  background-color: #e9ecef;\n  border-color: #adb5bd;\n}\n\n.pagination-button:disabled {\n  background-color: #f8f9fa;\n  border-color: #e9ecef;\n  color: #adb5bd;\n  cursor: not-allowed;\n}\n\n.pagination-button.active {\n  background-color: #007bff;\n  border-color: #007bff;\n  color: white;\n}\n\n.pagination-button.active:hover {\n  background-color: #0056b3;\n  border-color: #0056b3;\n}\n\n/* Final Videos Button */\n.final-videos-button {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 12px 20px;\n  background: #6c757d;\n  color: white;\n  border: none;\n  border-radius: 6px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  text-decoration: none;\n  transition: all 0.2s ease;\n  margin-right: 10px;\n  box-shadow: 0 2px 4px rgba(108, 117, 125, 0.3);\n}\n\n.final-videos-button:hover {\n  background: #5a6268;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 8px rgba(108, 117, 125, 0.4);\n}\n\n.final-videos-button svg {\n  flex-shrink: 0;\n}\n\n/* Read-only textarea styling for localhost */\ntextarea[readonly] {\n  background-color: #f8f9fa !important;\n  color: #6c757d !important;\n  cursor: not-allowed !important;\n  opacity: 0.8;\n}\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n  .master-project-controls {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 16px;\n  }\n\n  .search-container {\n    max-width: none;\n  }\n\n  .pagination-controls {\n    justify-content: center;\n  }\n\n  .pagination-button {\n    padding: 10px 14px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
